import { cdn } from "core/cdn"
import { Gender } from "types/entity"

const fr = {
  understood: "Compris",
  birthLocation_with_insee_code: "Lieu / INSEE de naissance",
  birth_lastname: "Nom de naissance",
  birth_location: "Lieu de naissance",
  birth_firstname: "Prénom de naissance",
  pseudo_firstname: "Prénom utilisé",
  pseudo_lastname: "Nom utilisé",
  verified_identity: "Identité vérifiée",
  add_pseudo_firstname: "AJOUTER UN PRENOM UTILISÉ",
  add_pseudo_lastname: "AJOUTER UN NOM UTILISÉ",
  identity_data: "Données d'identité",
  birth_names: "Prénom/Nom de naissance",
  pseudo_names: "Prénom/Nom utilisé",
  some_information_comes_from:
    "Certaines informations de votre profil ont été récupérées via votre",
  carte_vitale: "carte vitale",
  and_are_not: "et ne sont",
  modifiable: "pas modifiables.",
  sex: "Sexe :",
  you_can_add: "Vous pouvez ajouter ",
  a_pseudo_last_name_different: "un nom utilisé au quotidien, différent",
  a_pseudo_first_name_different: "un Prénom utilisé au quotidien, différent",
  of_your_birth_last_name: "de votre nom de naissance.",
  of_your_birth_first_name: "de votre Prénom de naissance.",
  not_informed: "Non renseignés",
  not_informed_singular: "Non renseigné",
  date_of_birth: "Date de naissance",
  code_insee: "Code INSEE de naissance",
  information_from_carte_vitale:
    "Voici les informations récupérées de votre carte vitale",
  look_and_verify_relatives_info:
    "Vérifiez et complétez l'identité de votre proche",
  ICanWait: "Patienter",
  IWantToLeave: "Quitter la file",
  doctorWillBeHereSoon: "Le médecin ne devrait plus tarder...",
  woudlYouRatherCancel:
    "Voulez-vous annuler la demande de téléconsultation et quitter la file ?",
  doctorIsComingInLessThanFiveMinutes: "Le médecin arrive dans moins de 5 min.",
  lessThanFiveMinutes: "moins de 5 min.",
  youCanJoinCallsRomm:
    "Vous pouvez dès à présent entrer en salle virtuelle et attendre le médecin quelques minutes.",
  joinVirtualRoom: "Entrer en salle virtuelle",
  accessibility_declaration: "Déclaration d'accessibilité",
  twoFa_choseMethodForResend:
    "Choisissez une méthode pour recevoir à nouveau le code de vérification.",
  twoFa_enterRecievedCode: "Entrez le code de vérification reçu",
  bySMSAt: "par SMS au",
  byPhoneAt: "par téléphone au",
  byEmail: "par Email",
  twoFa_enterValideCode: "Veuillez entrer un code valide.",
  twoFa_resendCode: "RENVOYER LE CODE",
  twoFa_codeHasBeenResentBy: (transport) =>
    `Le code a été renvoyé par ${transport}`,
  sms: "SMS",
  call: "Appel",
  voice: "appel téléphonique",
  twoFa_Titre: "Code de vérification",
  twoFa_invalidCode: "Le code de vérification est incorrect",
  twoFa_activationError:
    "Une erreur est survenue lors de l'activation du 2FA sur votre compte.",
  twoFa_ResendError:
    "Une erreur est survenue lors du renvoi du code de vérification.",
  twoFa_activateTitle:
    "Protégez votre compte en activant la double authentification (2FA)",
  twoFa_activateSubtitle:
    "Pour vous connecter à votre compte, en plus de votre mot de passe, vous recevrez un code à 6 chiffres.",
  diagnosis_authorization_on_going: "Autorisation en cours",
  retry: "Réessayer",
  relaunchTest: `RELANCER LE TEST`,

  iTurnedDevicesOff: "J'ai bien éteint les outils",
  pharmacistsPlease: "Pharmaciens, merci de bien vouloir :",
  authorizeAccess: `Autoriser l'accès au micro et/ou à la caméra, puis relancer le test.`,
  disconnectAndReconnect: `Débrancher et rebrancher le câble de la caméra, puis relancer le test.`,
  ifYouNeedHelp: `En cas de besoin, vous pouvez contacter le support au`,
  diagnosis_information_unknown_error:
    "Le micro et/ou la caméra ne semblent pas fonctionner. Merci de vous rapprocher du référent de la borne.",
  diagnosis_title_unknown_error: "Problèmes techniques détectés",
  diagnosis_contact_support:
    "Pharmacien, contactez le support en cas de besoin :",
  diagnosis_information_permission_denied:
    "Le micro et/ou la caméra ne semblent pas être autorisés par le navigateur. Merci de vous rapprocher du référent de la borne.",
  diagnosis_title_permission_denied:
    "La caméra et/ou le micro ne sont pas autorisés",
  diagnosis_information_waiting_device:
    "Vous devez autoriser le micro et la caméra.",
  diagnosis_title_waiting_device: "Demande d'autorisation en cours...",
  diagnosis_title_success: "Récupération des flux vidéos et audios",
  majorityRequired: "Majorité légale requise",
  minAgeMessage: (minAge: number) =>
    `L'âge doit être d'au moins ${minAge} ans.`,
  majorityRequiredInfo:
    "Le titulaire du compte doit être âgé d'au moins 16 ans au moment de son inscription.",
  majorityRequiredInfoFirstChunk: "Le titulaire du compte doit être âgé ",
  majorityRequiredInfoSecondChunk: "d'au moins 16 ans ",
  majorityRequiredInfoLastChunk: "au moment de son inscription.",
  majorityRequiredAddRelative:
    "Vous pourrez ajouter un proche mineur au moment de la téléconsultation.",
  createYourAccountBeforeAdddingChildRelative:
    "Si vous venez consulter pour votre enfant, veuillez créer votre propre compte dans un premier temps.",
  createChildRelativeAfter:
    "Une fois votre compte créé, vous pourrez ajouter votre enfant en tant que proche.",
  addChildRelativeWithYourOwnVitalCard:
    "Pour un enfant, le numéro de sécurité sociale à indiquer doit être celui du parent auquel il est rattaché",
  fix: "Corriger",
  keepThisNumber: "Conserver ce numéro",
  generalist: "Médecin généraliste",
  modifyInformations: "Modifier les informations",
  uploadDocumentQuestion:
    "Souhaitez-vous transmettre des documents médicaux au médecin ?",
  uploadDocumentTypesHints: "(analyses médicales, ordonnance, plaie, ...)",
  uploadDocumentAdd: "Importez puis sélectionnez les documents",
  uploadDocumentSelectOrAdd:
    "Sélectionnez les documents à envoyer ou ajoutez un nouveau document",
  uploadDocumentNoDocumentAvailable: "Aucun document",
  uploadDocumentAddButton: "Nouveau document",
  uDocScanQrCode: "Scannez le QR Code à l'aide de ",
  yourPhonesCamera: "la caméra de votre téléphone,",
  thenFollowTheSteop: " puis suivez les étapes indiquées",
  UDAskSms: "Demandez un lien par SMS, puis suivez les étapes indiquées",
  UDGetLinkBySms: "Recevoir le lien par SMS",
  UDSendMeSMS: "Ou recevoir le lien par SMS",
  UDCannotScan: "Je ne peux pas scanner le QR code",
  uploadDocumentTypeCrm: "Compte-rendu médical",
  uploadDocumentTypeOrdo: "Ordonnance",
  uploadDocumentTypeMT: "Médicaments / traitement",
  uploadDocumentTypeC: "Certificat",
  uploadDocumentTypeAG: "Analyses biologiques",
  uploadDocumentTypeCmd: "Courrier médical d'adressage",
  uploadDocumentSuccess: "Le document a bien été importé dans votre profil !",
  uploadDocumentTooLarge:
    "Le document dépasse la taille maximale de 10 Mo. Reprenez les photos en moins de pages.",
  uploadDocumentSuccessButton: "Continuer",
  uploadDocumentErrorTitle: "Oups...",
  uploadDocumentErrorSubtitle: "Une erreur est survenue !",
  uploadDocumentErrorRetryButton: "Reprendre",
  uploadDocumentSmsSentNotification: "Un SMS vient de vous être envoyé",
  uploadPhotoQualityConsent: "En envoyant cette photo, je comprends qu'une image de mauvaise qualité peut empêcher le dermatologue de rendre un avis.",
  uploadDocumentSendButton: "Transmettre les documents",
  UploadRecommendedText:
    "Afin de renouveler votre ordonnance, vous devriez transmettre une photo de votre document.",
  photoTransferText: `Afin d'analyser les résultats de biologie, merci de transmettre une photo des documents`,
  dermatoModalText: "Les motifs dermatologiques nécessitent l'envoi préalable de photos nettes et de bonne qualité des zones à examiner. Souhaitez-vous continuer sans rien transmettre ?",
  UploadPreviewDC:
    "Appuyer sur les flèches ou double-cliquer sur l'image frontale pour la visualiser en plus grand.",
  UDModalTransmit: "TRANSMETTRE",
  UDModalIgnore: "IGNORER",
  Renewal: "Renouvellement d'ordonnance",
  genericAPIError: "Une erreur est survenue.",
  relativeConsent: "L'ajout d'un proche sur MEDADOM necéssite son consentement",
  noCreditCardAdded: "Vous n'avez aucune carte d'enregistrée",
  noTLC: "vous n'avez pas de téléconsultation",
  yourCreditCards: "Vos cartes",
  subtitleCallAcceptedAndSoon:
    "est en consultation, vous êtes le prochain patient.",
  waitingDoctor: "Merci de patienter...",
  tagline: "Votre partenaire santé",
  chooseALanguage: "Choix de la langue",
  relaunchReader: "Veuillez relancer le lecteur ou passer à la suite",
  andYour: "Et votre",
  and: "Et",
  stayLogged: "Rester connecté",
  owner: "Titulaire",
  OtherRelative: "Autre proche",
  genericErrorPaymentCard:
    "Une erreur est survenue lors de l'ajout de votre moyen de paiement",
  setupIntentErrorStripe: "Impossible d'ajouter la carte.",
  genericErrorStripe:
    "Une erreur est survenue. Impossible de lancer la requête.",
  chooseThisRelative: "Choisir ce proche",
  beSureToBeDisconnected: "Êtes-vous sûr(e) de vouloir vous déconnecter ?",
  finishAndDisconnect: "Terminer et déconnexion",
  myAdministratorAccount: "Mon compte administrateur",
  launchFullVideoTuto: "Lancer la formation complète",
  launchChapterVideoTuto: "Parcourir les vidéos de formation",
  videoManual: "Vidéos d'utilisation de la borne",
  close: "Fermer",
  StartWithTheTerminal: "Démarrer sur la borne",
  WorkWithMedadom: "Travailler avec MEDADOM",
  TerminalOperation: "Fonctionnement du terminal",
  ClientParcours: "Parcours patient",
  ToolsUseCase: "Utilisation des outils",
  TheToolsUseCase: "L'utilisation des outils",
  UseCases: "Cas d'usage",
  TheUseCases: "Les cas d'usage",
  ContraIndications: "Contre-indications",
  TheContraIndications: "Les contre-indications",
  Path: "Parcours",
  ClientInscription: "Inscription du patient",
  HygieneProcedures: "Procédures d'hygiène",
  TheHygieneProcedure: "La procédure d'hygiène",
  Duration: "Durée",
  ProceduresAndBestPractices: "Procédures & bonnes pratiques",
  CheckupSante: "Check-up santé",
  MedPayPro: "Med'Pay Pro",
  confirmTheSendingOfYourDocuments:
    "Confirmez-vous l'envoi de vos documents au pharmacien* ?",
  myStatistics: "Mes statistiques",
  statistics: "Statistiques",
  statisticsSendWithSuccess: "Les statistiques vous ont été envoyées par email",
  statisticsSendWithFailure:
    "Une erreur est survenue, veuillez réessayer plus tard",
  myTutorialVideos: "Vidéos de formation",
  teleexpertiseCta: "Téléexpertise",
  otherSettingsCta: "Autres réglages",
  settingsMssCta: "MSS",
  mssSettingsTitle: "Messagerie sécurisée de santé (MSS)",
  mssSettingsToggleLabel: "Recevoir les communications par MSS",
  mssSettingsScope: "Ces réglages sont liés au titulaire de cette borne.",
  mssSettingsNeedsRpps: "Renseignez d'abord le RPPS du titulaire dans Téléexpertise, Informations du titulaire.",
  ownerInfoTitle: "Informations du titulaire",
  ownerInfoRppsLabel: "RPPS :",
  ownerInfoFinessLabel: "FINESS :",
  ownerInfoMssLabel: "Adresse MSS :",
  ownerInfoMssEnterHeading: "Veuillez saisir l'adresse e-mail MSS du titulaire",
  ownerInfoMssRecoveredHeading: "Veuillez confirmer l'adresse MSS récupérée avec votre RPPS",
  ownerInfoMssPlaceholder: "e-mail",
  ownerInfoRppsNotRecognized: "Ce numéro RPPS n'est pas reconnu. Veuillez vérifier votre saisie.",
  ownerInfoMissingRpps: "Pour enregistrer cette information, veuillez également renseigner le RPPS du titulaire.",
  ownerInfoMissingFiness: "Pour enregistrer cette information, veuillez également renseigner le FINESS de facturation.",
  ownerInfoMssNotSaved: "L'adresse e-mail MSS n'a pas pu être enregistrée. Veuillez réessayer plus tard.",
  ownerInfoSaved: "Information enregistrée",
  ownerInfoMssInvalidDomainPrefix: "L'adresse MSS doit être une adresse e-mail se terminant par",
  ownerInfoMssDomain: ".mssante.fr",
  ownerInfoMssDeactivate: "Désactiver",
  ownerInfoMssOptOutTitle: "Ne pas recevoir les communications par MSS",
  ownerInfoMssOptOutText:
    "En refusant les communications par MSS, vous ne recevrez aucune information concernant vos demandes de télémédecine, et pourriez manquer des informations importantes.",
  ownerInfoMssOptOutReactivateHint: "Vous pourrez les réactiver à tout moment depuis cet écran.",
  ownerInfoMssSkipAccept: "Passer l'étape",
  ownerInfoMssMissingTitle: "Vous n'avez pas renseigné votre adresse MSS",
  ownerInfoMssMissingText: "Sans adresse MSS, vous ne recevrez aucune information sur vos demandes de téléexpertise.",
  ownerInfoMssMissingQuestion: "Souhaitez-vous la renseigner maintenant ?",
  ownerInfoMssMissingCta: "Renseigner ma MSS",
  ownerInfoMssOptOutNotSaved: "Votre choix n'a pas pu être enregistré. Veuillez réessayer plus tard.",
  pharmaSupportIntro: "En cas de question, vous pouvez contacter le support:",
  pharmaSupportFrom: "Du",
  pharmaSupportDays: "lundi au samedi",
  pharmaSupportHoursPrefix: "de",
  pharmaSupportHours: "9h à 19h30",
  pharmaSupportPhonePrefix: "au",
  pharmaSupportPhone: "01 86 65 55 15",
  pharmaSupportEmailPrefix: "à l'adresse",
  pharmaSupportEmail: "contact@medadom.com",
  modal_pharmaAccount_title: "Espace professionnel",
  select_reason: "Selectionnez un motif ...",
  select_birth_location: "lieu de naissance",
  anamneseReasonQuestion: "Quel est le motif de votre consultation ?",
  anamneseReasonQuestion_relative_male:
    "Quel est le motif de consultation de votre proche ?",
  anamneseReasonQuestion_relative_female:
    "Quel est le motif de consultation de votre proche ?",
  birthCity: "lieu de naissance",
  birthCountry: "pays de naissance",
  birthLocation: "Lieu de naissance",
  createCardSuccess: "Votre carte a été ajoutée",
  createCardError: "Votre carte n'a pas pu être ajouté",
  city: "Ville",
  covidHTML: `Coronavirus\r\n (Covid 19)`,
  covid: "Coronavirus (Covid 19)",
  allergy: "Allergies",
  burn: "Brûlure",
  contraception: "Contraception",
  cystitis: "Cystite",
  jointpain: "Douleurs articulaires (genou, poignet)",
  jointpainWithoutParenthesis: "Douleurs articulaires",
  diarrhea_or_vomiting: "Diarrhée ou vomissement",
  toothpain: "Douleurs dentaires",
  back_pain: "Douleurs lombaires",
  rash: "Éruption cutanée",
  tired: "Fatigue / anxiété / stress",
  fever: "Fièvre",
  sexual_infection: "Infection sexuelle",
  sore_throat: "Maux de gorge",
  headache: "Maux de tête",
  stomach_ache: "Maux de ventre",
  eye_pain: "Œil rouge et/ou douleur",
  cancel_warning:
    "En cas d'annulation, vous perdrez votre place dans la file d'attente.",
  sting: "Piqûre / morsure / blessure",
  otitis: "Oreilles/otite",
  prescription_refill: "Renouvellement d'ordonnance",
  period_pain: "Règles douloureuses",
  lab_results: "Résultats de laboratoire",
  cold_and_flu: "Rhume et syndrome grippal",
  sinus: "Sinus ou nez bouché",
  cough: "Toux",
  otherReason: "Autre",
  DMLA: "DMLA",
  DoYouHaveANir: "Avez-vous une carte vitale ?",
  IHaveAccount: "J'ai déjà <b style='font-weight:normal'>un compte</b>",
  IHaveNoAccount: "Je n'ai pas <b style='font-weight:normal'>de compte</b>",
  IHaveNoEmail: "J'atteste ne pas avoir d'adresse e-mail",
  IwantToAddAnEmail: "JE RENSEIGNE MON E-MAIL",
  IHaveNoNir: "Je n'ai pas de numéro de sécurité sociale",
  IHaveNir: "J'ai une carte vitale",
  RelativeHasNir: "Le proche a une carte vitale",
  TooManyRequest: "Trop de requêtes. Veuillez réessayer ultérieurement",
  WhenWasThelastConsultation:
    "A quand remonte votre dernière consultation (physique) chez un orthoptiste/ophtalmologiste ?",
  aPatientLogged: "Un patient est en cours d'utilisation : ",
  ame: "Aide Médicale d'État",
  c2s: "Couverture Maladie Universelle",
  ald: "Affection Longue Durée",
  indicateYourRights: "Merci d'indiquer vos droits :",
  indicateRelativeRights: "Merci d'indiquer les droits de votre proche :",
  rightsAttest:
    "j'atteste sur l'honneur que je bénéficie de la C2S (CMU ou AME) ou de l'ALD. Dans le cas contraire, je m'expose à des poursuites.",
  rightsAttestRelative:
    "j'atteste sur l'honneur que mon proche bénéficie de la C2S (CMU ou AME) ou de l'ALD. Dans le cas contraire, je m'expose à des poursuites.",
  ameModalTitle: "Attestation sur l'honneur",
  fraudIsPunished: "Toute fraude à l'Assurance Maladie est punie",
  ameModalAccept: "J'atteste sur l'honneur la validité",
  ameModalCancel: "Je ne bénéficie pas",
  ameModalCancelRelative: "Mon proche ne bénéficie pas",
  estimatedTime: "Attente estimée",
  yourPaymentMethod: "Votre moyen de paiement",
  youWillPayOnlyAfterConsultation:
    "Vous ne serez facturé qu'à la fin de la téléconsultation",
  ameRelativeBenefit: "Le proche bénéficie de la C2S (ex-CMU), AME, ALD",
  WeAutomaticallyDetectedBenefit:
    "La carte vitale nous indique votre appartenance C2S (ex-CMU), AME, ALD, 100%",
  ameIBenefit: "Je bénéficie de la C2S (ex-CMU), AME, ALD",
  ameModalContent: `<table class="table-modal">
        <tr> 
          <td> 
            <img src="${cdn("icons/carte_vitale_picto.svg")}"> 
          </td>
          <td>
            <span class="modal-content">
            <b>Si vous êtes bénéficiaire de la C2S (ex-CMU) ou AME ou ALD, vous bénéficiez d'une exonération de frais.</b>
            Pour cela, vous devez impérativement avoir une attestation à jour de votre Couverture Maladie Universelle, de votre Aide Médicale d'État, ou de votre Affection Longue Durée.
          </span>
            </td>
        </tr>
        <tr>
          <td> 
            <img src="${cdn("icons/pharmacien_picto.svg")}"> 
          </td>
          <td>
            <span class="modal-content">
            Celle-ci pourra être vérifiée par le pharmacien.
            </span>
          <td>
        </tr>
        <tr>
          <td> 
            <img src="${cdn("icons/attestation_honneur_picto.svg")}"> 
          </td>
          <td>
            <span class="modal-content">
            <b>
            J'atteste sur l'honneur que je respecte les conditions énoncées ci-dessus pour une exonération des frais,
            et dans le cas contraire je m'expose à des poursuites.
            </b>
            </span>
          </td>
        </tr>
        <table>`,
  cardRefused: "Paiement refusé",
  paymentFailed: "Paiement échoué",
  useAnotherPaymentMethod:
    "Merci de réessayer ou d'utiliser un autre moyen de paiement.",
  errorPaymentModalTitle:
    "Votre carte de paiement a été refusée par notre prestataire de paiement. Merci de vous assurer que :",
  errorPaymentModalChangeCard: "Changer de carte",
  errorPaymentModalRetry: "Réessayer",
  errorPaymentModal_html: `
    <table class="table-modal small">
        <tr>
          <td> 
            <img src="${cdn("icons/picto_paiement.svg")}"> 
          </td>
          <td>
            <span class="modal-content">
              Vous avez des <b>fonds suffisants sur votre compte bancaire</b>
            </span>
          <td>
        </tr>
        <tr>
        <td> 
          <img src="${cdn("icons/picto_internet.svg")}"> 
        </td>
        <td>
          <span class="modal-content">
            Vous avez <b>activé le paiement sur internet</b>
          </span>
        <td>
      </tr>
      <tr>
        <td> 
          <img src="${cdn("icons/picto_3ds.svg")}"> 
        </td>
        <td>
          <span class="modal-content">
          Vous avez <b>activé le 3DSecure</b> le cas échéant (double authentification des paiements en ligne)
          </span>
        <td>
      </tr>
      <tr>
        <td> 
          <img src="${cdn("icons/picto_carte_valide.svg")}"> 
        </td>
        <td>
          <span class="modal-content">
          <b>Votre carte est valide</b> pour le paiement
          </span>
        <td>
      </tr>
    <table>
    <div class="center" style="margin-top:20px"> 
      <b class="error">En cas de besoin, merci de contacter votre banque pour confirmation</b>
    </div>
    `,
  accountCreated: "Votre compte a bien été créé",
  accountError: "Votre compte n'a pas pu être créé",
  addARelative: "Ajouter un proche",
  addCreditCard: "Ajouter la carte",
  addPaimentMethod: "Ajouter une carte de crédit",
  backToPaymentMethod: "Revenir aux moyens de paiement",
  addPhoneNumber: "L'ajouter",
  addRelative: "Ajouter le proche",
  adminInformationWelcome:
    "L'équipe Medadom vous a transmis par mail, lors de votre inscription, votre identifiant ainsi que votre mot de passe. Merci de vous connecter ici avec ces identifiants. Contactez nous au 01 86 65 55 15 en cas de problème.",
  agreement: "Consentement",
  consentOfAssistance: "Consentement de l'accompagnant",
  agreementInvalid: "Vous devez accepter les CGUs",
  alreadyAcount: "J'ai déjà un compte patient Medadom",
  anamneseAllergiesQuestionSubtitle: "(Pollen, médicamenteuse, ...)",
  anamneseAllergiesQuestion: "Avez-vous des allergies connues ?",
  anamneseAllergiesQuestion_relative_male:
    "Votre proche a-t-il des allergies connues ?",
  anamneseAllergiesQuestion_relative_female:
    "Votre proche a-t-elle des allergies connues ?",
  anamneseAllergiesQuestionDetails: "Quelle(s) allergie(s) ?",
  anamneseDrugsQuestion: "Prenez-vous régulièrement des médicaments ?",
  anamneseDrugsQuestion_relative_male:
    "Votre proche prend-il régulièrement des médicaments ?",
  anamneseDrugsQuestion_relative_female:
    "Votre proche prend-elle régulièrement des médicaments ?",
  anamneseIllnessQuestionSubtitle: "(Diabète, hypertension, ...)",
  anamneseIllnessQuestion: "Avez-vous déjà eu des maladies chroniques ?",
  anamneseIllnessQuestion_relative_male:
    "Votre proche a-t-il déjà eu des maladies chroniques ?",
  anamneseIllnessQuestion_relative_female:
    "Votre proche a-t-elle déjà eu des maladies chroniques ?",
  anamneseIllnessQuestionDetails: "Quelle(s) maladie(s) chronique(s) ?",
  anamneseOperationsQuestion: "Avez-vous déjà été opéré(e) ?",
  anamneseOperationsQuestion_relative_male:
    "Votre proche a-t-il déjà été opéré ?",
  anamneseOperationsQuestion_relative_female:
    "Votre proche a-t-elle déjà été opérée ?",
  anamnesePregnantQuestion: "Êtes-vous enceinte ou allaitez-vous ?",
  anamnesePregnantQuestion_relative_female:
    "Votre proche est-elle enceinte ou allaite-t-elle ?",
  antecedents: "Avez-vous des antécédents ophtalmologiques ?",
  apr: "Avril",
  askAgain: "Relancer la demande",
  ask_for_phone_re_enter: "Merci de rentrer de nouveau le téléphone du patient",
  ask_for_voiceCall: "Recevoir le code par appel téléphonique",
  aug: "Août",
  averageConsultationTime: "Durée moyenne des examens",
  backToHome: "Retour à l'accueil",
  birthdate: "Date de naissance",
  birthdateModal: "Entrez la date de naissance du titulaire du compte",
  birthdatePlaceholder: "JJ / MM / AAAA",
  byPassEmail: "Je n'ai pas d'e-mail",
  byPassNir: "Je n'ai pas de numéro de sécurité sociale",
  enterRelativeNir:
    "Saisissez le numéro de sécurité sociale du bénéficiaire des droits",
  byPassNir_relative: "Le proche n’a pas de numéro de sécurité sociale",
  noBill: "Vous ne serez pas facturé.",
  doctorCancelCall:
    "Nous sommes navrés, le médecin a annulé la téléconsultation",
  callCancelled: "Annulée",
  callCannotBeCancelled: "Nous n'avons pas pu annuler la consultation",
  callExpired: "Expirée",
  callHasBeenCancelled: "La téléconsultation a été annulée",
  callMeVerify: "Recevoir un appel pour le code",
  call_ophtalmologist: "téléconsultation avec l'ophtalmologiste",
  call_ortho: "téléconsultation avec l'orthoptiste",
  call_page: "teleconsultation",
  cancel: "Annuler",
  cancelAndDisconnect: "Annuler et se déconnecter",
  cancelCall: "Annuler la consultation",
  cancelConsultation: "ANNULER MA DEMANDE",
  continueConsultation: "Poursuivre l'attente",
  cancelTLC: "Vous allez annuler la demande de téléconsultation",
  cancer: "cancer",
  cannotLaunchTlc: "Impossible de lancer la consultation",
  cataract: "Cataracte",
  cguAgreement:
    "J'ai lu et accepte <b>les conditions générales d'utilisation</b>, ainsi que le traitement de mes données personnelles de santé pour l'utilisation du service",
  cguAndPrivacyTitle: "Conditions générales et données personnelles",
  change_phone: "Changer de numéro",
  childLessThanSix: "les enfants de moins de 6 ans",
  choseYourCountry: "Veuillez indiquer le pays",
  civility: "Civilité",
  clickMeToVanish: "puis cliquez-moi pour disparaitre !",
  comeBackToLogin: "Revenir à la connexion",
  comeBackToSurvey: "Revenir au parcours",
  confirm: "Confirmer",
  medicalcenter: "Centre de santé",
  chooseYourNationality: "Choisissez votre lieu de naissance",
  confirmHangupCall:
    "Êtes-vous sûr(e) de vouloir raccrocher la téléconsultation ?",
  confirmCancelCall: "Êtes-vous sûr(e) de vouloir annuler la demande ?",
  connectedAs: "Connecté en tant que ",
  consultationScheduledAt:
    "a confirmé la téléconsultation pour ce créneau. Il peut avoir du retard, merci de patienter.",
  contact_secretary:
    "Veuillez contacter le secrétériat \r\n afin de créer votre compte",
  continue: "Continuer",
  save: "Enregistrer",
  IUnderstandAndContinue: "Je comprends et poursuis",
  createCall: "Lancer la consultation",
  creating_call: "Demande en cours",
  credit: "© 2021 MEDADOM Tous droits réservés",
  creditCard: "carte bancaire",
  waintingForCardInsertion: "En attente de l'insertion de la carte",
  waitingForCardPayment: "En attente du paiement par carte...",
  presentYourCardOnTheTerminal: "Présentez votre carte sur le terminal",
  paymentTimeout: "Le paiement n'a pas été effectué dans le temps imparti.",
  delayPassed: "Délai dépassé",
  paymentCancelled: "Paiement sans contact annulé",
  initializingPayment: "Initialisation du paiement...",
  dateInvalid: "La date de naissance est invalide",
  dec: "Décembre",
  defaultErrorForm: "Une erreur s'est glissée dans le formulaire",
  defaultReplyWhichWho: "L'un de nos médecins disponible",
  deleteCard: "Supprimer la carte",
  deleteRelative: "Supprimer le proche",
  deleteRelativeConfirmContent:
    "$RELATIVE_NAME$ sera <b>définitivement supprimé</b> de la liste de vos proches. Son <b>historique</b> et ses <b>documents</b> seront cependant <b>conservés</b>.",
  demo: "la démonstration des machines",
  demo_page: "demonstration-outils",
  diabetes: "diabète",
  digestiveDisease: "maladie digestive",
  doYouHaveAnAccount: "Avez-vous un compte MEDADOM ?",
  anamneseChoiceOfDoctor: "Que souhaitez-vous faire ?",
  anamneseConsultNow: "Consulter <b>dès maintenant</b>",
  consultNow: "Consulter dès maintenant",
  now: "maintenant",
  availability: "Disponibilité",
  thisDoctorIsNotAvailable_html:
    "Ce médecin est indisponible, mais un médecin du <b>CDS Mediksanté (Paris)</b> peut vous <b>prendre en charge immédiatement</b>",
  IConsultThisDoctor: "Je veux consulter ce médecin",
  ifDoctorDoNotExist:
    "Si le médecin que vous cherchez ne consulte pas encore sur MEDADOM, vous pourrez consulter un autre médecin disponible",
  requestDoctorPlaceholder: "Nom et/ou prénom",
  addressNotProvided: "Adresse non fournie",
  searchDoctorInstruction: "Merci de renseigner nom et/ou prénom de votre médecin traitant pour le trouver",
  searchMinLengthInstruction: "Saisissez au moins 2 caractères pour lancer la recherche",
  noDoctorsFound: "Aucun médecin trouvé, merci de bien renseigner le nom puis le prénom complet du médecin",
  treatingDoctor: "Médecin traitant",
  treatingDoctorResultsTitle: "Nom de votre médecin traitant",
  noTreatingDoctorSet: "Vous n'avez pas encore renseigné de médecin traitant",
  pleaseWait: " Merci de patienter...",
  cancelling: "Annulation en cours...",
  connectionLostReconnecting:
    "Connexion interrompue. Reconnexion en cours, merci de patienter...",
  doctorConnectionUnstable:
    "La connexion du médecin est instable. Merci de patienter...",
  anamneseChooseADoctor: "J'ai RDV avec un <b>médecin spécifique</b>",
  chooseADoctor: "J'ai rendez-vous avec un médecin spécifique",
  anamneseChooseADoctor_relative_female:
    "Ma proche a RDV avec un <b>médecin spécifique</b>",
  anamneseChooseADoctor_relative_male:
    "Mon proche a RDV avec un <b>médecin spécifique</b>",
  anamneseDoctorAvailableQuestion: "Quelle est votre situation ?",
  nirIsExpiredTitle: "Votre Carte Vitale n'est pas à jour !",
  nirIsExpiredContent: `<span>
      Cela peut avoir une incidence sur le remboursement de votre téléconsultation,
    </span>
        <br />
    <b>
      mettez là à jour auprès de votre pharmacien
    </b>`,
  anamneseDoctorAvailableQuestion_relative_male:
    "Quelle est la situation de votre proche ?",
  anamneseDoctorAvailableQuestion_relative_female:
    "Quelle est la situation de votre proche ?",
  doNotHaveDoctor: "<b>Je n'ai pas</b> de médecin traitant",
  noLongerHaveDoctor: "Je n'ai plus de médecin traitant",
  noLongerHaveDoctor_relative: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "Elle n'a plus de médecin traitant"
      : "Il n'a plus de médecin traitant",
  removeFamilyDoctorText:
    "Le médecin traitant sera supprimé de votre profil. Vous pourrez en ajouter un nouveau à tout moment",
  removeFamilyDoctorText_relative: (gender: Gender) =>
    `Son médecin traitant sera supprimé de son profil. ${gender === Gender.FEMALE ? "Elle" : "Il"} pourra en ajouter un nouveau à tout moment`,
  removeFamilyDoctorAccept: "Supprimer et continuer",
  removeFamilyDoctorError:
    "Impossible de supprimer le médecin traitant. Veuillez réessayer.",
  doctorNotAvailable: "Mon médecin traitant <b>n'est pas disponible</b>",
  doctorFarAway: "Je <b>suis loin</b> de mon médecin traitant (déplacement, vacances, ...)",
  doNotHaveDoctor_relative: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "Elle <b>n'a pas</b> de médecin traitant"
      : "Il <b>n'a pas</b> de médecin traitant",
  doctorNotAvailable_relative: (_gender: Gender) =>
    "Son médecin traitant <b>n'est pas disponible</b>",
  doctorFarAway_relative: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "Elle <b>est loin</b> de son médecin traitant (déplacement, vacances, ...)"
      : "Il <b>est loin</b> de son médecin traitant (déplacement, vacances, ...)",
  doctorNotInList: "Mon médecin n'est pas dans la liste",
  doctorAwaiting: "Votre médecin est prêt ! Votre consultation va commencer.",
  waitInFrontOfTheScreen: "Veuillez patienter devant l'écran...",
  documentAvailableInfo:
    "Retrouvez vos documents médicaux dans votre espace Medadom",
  documentAskToScan:
    "Un <b>souci</b> avec vos <b>documents médicaux</b> ? <br /> Demandez à votre <b>pharmacien de scanner le QR code</b> présent sur <b>l'ordonnance !</b>",
  inTab: ", dans l'onglet ",
  deviceAreON: "L'otoscope (A) et/ou le dermatoscope (D) sont allumés.",
  documents: "Documents",
  drugAllergy: "autre allergie médicamenteuse",
  foodAllergy: "allergie alimentaire",
  penicillinAllergy: "allergie à la pénicilline",
  email: "e-mail",
  Email: "E-mail",

  notSuitableTLC: "Téléconsultation non adaptée",
  IHaveRelativeConsent: "J'ai le consentement",
  enterRelativeInformations: "Ajout d'un proche",
  enterYourBirthFirstname: "Veuillez entrer votre prénom de naissance",
  enterYourBirthLastname: "Veuillez entrer votre nom de naissance",
  enterYourBirthLocation: "Veuillez entrer votre lieu de naissance",
  enterRelativeBirthFirstname:
    "Veuillez entrer le prénom de naissance de $RELATIVE_NAME$",
  enterRelativeBirthLastname:
    "Veuillez entrer le nom de naissance de $RELATIVE_NAME$",
  enterRelativeBirthLocation:
    "Veuillez entrer le lieu de naissance de $RELATIVE_NAME$",
  enter_lastname: "Veuillez saisir votre nom de famille",
  InputYourOldPassword: "Veuillez entrer votre ancien mot de passe",
  InputYourPassword: "Confirmez votre mot de passe",
  enter_password:
    "Définissez un mot de passe, \n\r pour la création de votre compte Medadom",
  enter_phone: "Rentrez votre numéro de téléphone",
  notSuitableTLCContent:
    "Les enfants de <b>moins de 3 ans</b> nécessitent un examen clinique.<br/>La téléconsultation n'est pas adaptée à cette prise en charge et  n'est donc <b>pas possible</b> dans ce cas.",
  IGotIt: "J'ai compris",
  maxThreeReasonsTitle: "Veuillez sélectionner 3 motifs maximum",
  errorCallState:
    "Une erreur est survenue lors du call, \n\r Veuillez contacter notre support",
  errorLogin: "Une erreur s'est glissée dans le formulaire",
  errorOccuredWhenSendingCode:
    "Une erreur est survenue lors de l'envoi du code",
  existingOrderError: "La téléconsultation existe déjà",
  expiredSession: "La session est expirée. Nous allons vous déconnecter.",
  feb: "Février",
  female: "Femme",
  finalePageTitle: "Merci de votre visite !",
  firstConsultation: "1ère consultation lunettes",
  firstname: "Prénom utilisé au quotidien",
  first_birth_firstname: "1er Prénom de naissance",
  first_firstname: "Prénom",
  first: "1er",
  of_birth: " de naissance",

  forMe: "Pour moi",
  forgottenPassword: "J'ai oublié mon mot de passe",
  gender: "Genre",
  honorificTitle: "Civilité",
  glassesRenewal: "Renouvellement des lunettes",
  glaucoma: "Glaucome",
  errorDate_shouldBeOlderThan: (minAge?: number) =>
    `Vous devez avoir plus de ${minAge || 3} ans.`,
  errorDate_shouldBeYoungerThan: (maxAge?: number) =>
    `La téléconsultation n'est pas possible après ${maxAge || 110} ans`,
  invalideDate: "Date de naissance incomplète ou erronée",
  DD: "JJ",
  MM: "MM",
  YYYY: "AAAA",
  goBackToProfile: "Retour au profil",
  helper: "L'équipe MEDADOM vous informe :",
  doctorIsWritingYourDocs:
    "Le médecin est en train de rédiger vos documents médicaux...",
  stepCanTake: "Cette étape prend généralement",
  timeWaitingHungup: "5 à 10 minutes.",
  findDocumentsInYourProfile:
    "Retrouvez à tout moment vos documents médicaux depuis votre espace MEDADOM.",
  followingInstructions_html: (deviceName?: string) =>
    `Placer<br/><b>${deviceName ?? "l'objet"
    }</b><br/>selon les instructions du médecin`,
  putDown: (deviceName?: string) =>
    `Reposer <br/> <b>${deviceName ?? "l'objet"}</b>`,
  helperRegardingGenderRelative:
    "Vérifiez bien le genre de la personne que vous ajoutez !",
  hangup: "Raccrocher",
  hangupTitleWarning: "Souhaitez-vous raccrocher ?",
  hangup_subtitle: "Veuillez patienter quelques instants...",
  heartDisease: "maladie cardiaque",
  hypertension: "hypertension",
  IRefuseConsent: "Annuler",
  IAcceptConsent: "J'accepte",
  consentTitleModal: "CGU",
  consentContentModal: `J'ai lu et accepte <a>les conditions générales d'utilisation</a>, ainsi que le traitement de mes données personnelles de santé pour l'utilisation du service`,
  contraceptionModalNotSuitable_html: `Pour ce motif, la téléconsultation <b>n'est pas possible</b> dans les cas suivants :`,
  contraceptionModalNotSuitableReason1_html: `Prescription <b>initiale</b> de contraception`,
  contraceptionModalNotSuitableReason2: "Demande d’IVG médicamenteuse",
  inProgress: "En cours...",
  inactivity: "Vous allez être déconnecté pour inactivité",
  incorrectInput: "Merci d'entrer un champs valide pour",
  infectiousDisease: "maladie infectieuse",
  inform_anamnesis:
    "Le médecin a besoin de certaines informations médicales vous concernant",
  initial_step: "Parcours de votre téléconsultation",
  inform_anamnesis_relative_male:
    "Le médecin a besoin de certaines informations médicales concernant le proche",
  inform_anamnesis_relative_female:
    "Le médecin a besoin de certaines informations médicales concernant la proche",
  inputYour: "Entrez votre ",
  enterThe: "Entrez le ",
  inputYourBirthCountry: "Entrez votre pays de naissance",
  inputYourBirthCity: "Entrez votre lieu de naissance",
  inputYourRelativeBirthCity: "Entrez le lieu de naissance du proche",
  inputYourRelativeBirthCountry: "Entrez le pays de naissance du proche",
  unknownBirthPlace: "Passez à l'étape suivante",
  insertYourNir: "Insérez votre carte vitale",
  createPassword: "Veuillez créer un mot de passe",
  ineligibleReasonInformation:
    "Pour ces motifs, vous devez vous rendre chez votre médecin traitant ou consulter un médecin en présentiel.",
  invalidValidationCode:
    "Une erreur est survenue lors de la validation du code",
  invalid_password: "Mot de passe invalide",
  jan: "Janvier",
  joinCallIn: "Rejoignez l'appel dans",
  joinTheConsultation: "Rejoindre la consultation",
  jul: "Juillet",
  jun: "Juin",
  keratoconus: "Kératocône",
  kidneyDisease: "maladie rénale",
  lastname: "Nom utilisé au quotidien",
  birthLastname: "Nom de naissance",
  launch_tlc: "Lancer une téléconsultation",
  legalMentionArticleSix:
    "Conformément à l'article 6 du code de la santé publique, vous êtes libre du choix de votre opticien",
  lensesRenewal: "Renouvellement des lentilles",
  lessThan: "Moins de",
  lessThanAYear: "Moins d'1 an",
  locationError: "Veuillez renseigner un lieu valide",
  locationInvalid: "Veuillez selectionner un lieu de naissance",
  locationAddress: "Lieu de naissance",
  locationAddressError: "lieu de naissance invalide",
  login: "Se connecter",
  loginNir: "Valider",
  loginTitle: "J'ai déjà un compte patient",
  logoutTitle: "Souhaitez-vous être déconnecté ?",
  logout: "Se déconnecter",
  logoutAdmin: "Déconnexion pharmacie",
  male: "Homme",
  mar: "Mars",
  may: "Mai",
  me: "moi",
  medikSante: "MedikSanté",
  mismatchingErrorForm:
    "Les identifiants ne correspondent pas : vérifiez identifiant et mot de passe",
  mustContainLessThanHundredCharacters:
    "Le champ doit contenir moins de 100 caractères",
  cantContainSpaceAsFirstCharacters:
    "Le premier caractère ne peut être un espace ou tiret",
  cantContainTwoConsecutiveSpace:
    "Le champ ne peut contenir deux espaces consécutifs",
  cantContainTwoConsecutiveApostrophe:
    "Le champ ne peut contenir deux apostrophes consécutifs",
  cantContainTwoConsecutiveHyphen:
    "Le champ ne peut contenir que deux tirets consécutifs",
  cantContainHyphenFollowedByApostrophe:
    "Le champ ne peut contenir un tiret suivi d'un apostrophe ",
  cantContainHyphenFollowedBySpace:
    "Le champ ne peut contenir un tiret suivi d'un espace",
  cantFinishWithHyphenOrApostrophe:
    "Le champ ne peut pas finir par un tiret ou un apostrophe",
  shouldStartWithAlphaOrApostrophe:
    "Le champ doit commencer par un caractère ou un apostrophe",
  shouldContainAtLeastOneAlphaCharacter:
    "Le champ doit contenir au moins un caractère alphanumérique",
  shouldNotContainSlash: "Le champ ne peut contenir de slash",
  modify: "Modifier",
  ofTheRelative: "du proche",
  modifyRelative: "Modifier mon proche",
  of: "de",
  label_input_the_male: "Entrez le ",
  enter1erFirstname: "Entrez le 1er Prénom de naissance",

  inputThe: (name: string) => {
    if (["birthdate"].includes(name)) return "Entrez la " + fr[name]
    else return "Entrez le " + fr[name]
  },
  modifyThe: (name: string) => {
    return "Modifiez le " + fr[name]
  },
  modifyYour: (name: string) => {
    return "Modifiez votre " + fr[name]
  },

  addA: (name: string) => {
    return "Ajouter un " + fr[name]
  },

  nirWellKnown: "Le numéro de carte vitale est bien enregistré",
  exemptionEnded:
    "Fin de la mesure gouvernementale Covid-19 sur le tiers payant intégral. À compter du 1er octobre 2022, le patient devra à nouveau s'acquitter de la part complémentaire (remboursée par la mutuelle)",
  tlcExemptedDate: "Au 1er octobre 2022",
  tlcExemptedContent:
    "la prise en charge règlementaire de la Sécurité Sociale redeviendra de 70%, et le reste à charge de 30% (remboursable par votre mutuelle). Le contexte sanitaire actuel exonère d'avance de frais en téléconsultation jusqu'au 30/09/2022.",
  nextMeansYouAcceptCGU:
    "En poursuivant la demande, je confirme avoir pris connaissance des CGU",
  putHeadPhones: "Si la borne en est équipée, mettez le casque audio",
  moreThanAYear: "Plus d'1 an",
  needHelp: "Besoin d'aide ?",
  next: "Suivant",
  skip: "passer",
  conflictError: "Déjà existant",
  nexmoError:
    "Ce numéro de téléphone ne peut être validé. Merci d'essayer avec un autre numéro",
  nir: "Numéro de sécurité sociale",
  nirInvalid: "Le numéro de sécurité sociale n'est pas valide",
  nirLengthError: "Le numéro de sécurité sociale doit contenir 15 chiffres",
  rppsLengthError: "Le RPPS/Adeli doit contenir un maximum de 11 chiffres",
  nirManualInput: "Passer l'étape",
  nirReaderError: "Nous n'avons pas pu récupérer les informations",
  codeSpacer: " ",
  codeAllowedChar: "9",
  nirMaskChar: "_",
  nirAllowedChar: "*",
  no: "NON",
  youWillBeInformedBySMS: "En cas d'avance, vous serez prévenu(e) par sms",
  youWillBeInformedBySMSFifo:
    "Vous serez prévenu(e) par SMS avant le début de votre téléconsultation",
  noAppointment: "Je n'ai pas de rendez-vous",
  noAppointment_relative_male: "Mon proche n'a pas de rendez-vous",
  noAppointment_relative_female: "Mon proche n'a pas de rendez-vous",
  noDocument: "le docteur n'a délivré aucune ordonnance",
  noEmailContentModal: `<div>
      <div class="center" style="margin-bottom:80px">
        <img  src="${cdn("icons/mail_picto.svg")}" alt="">
      </div>
      <table class="table-modal">
        <tr>
          <td></td>
          <td><b>En ne renseignant pas votre adresse email :</b></td></tr>
        <tr>
          <td><img height="100" src="${cdn("icons/supprimer.svg")}" alt=""></td>
          <td>Vous ne pourrez recevoir d'informations sur les documents médicaux liés à votre consultation.</td>
        </tr>
        <tr>
          <td><img height="100" src="${cdn("icons/supprimer.svg")}" alt=""></td>
          <td>Nos équipes médicales et administratives ne pourront vous contacter en cas de besoin.</td>
        </tr>
      </table>
    </div>`,
  noEmailTitleModal: "Adresse e-mail obligatoire",
  noNirTitleModal: "Attention",
  bornThe: "Né(e) le ",
  noNirContentModal:
    `<b>Sans numéro</b> de sécurité sociale, vous devrez <b>payer la totalité du montant</b> de la téléconsultation.`,
  noHistory: "Pas d'historique",
  notAdapted: "La téléconsultation n'est pas adaptée pour :",
  notBornInFrance: "Je ne suis pas né(e) en France ?",
  bornInFrance: "Je suis né(e) en France ?",
  relativeBornInFrance: "Le proche est né(e) en France ?",
  relativeNotBornInFrance: "Le proche n'est pas né(e) en France ?",
  french: "France",
  foreign: "Étranger",
  unknown: "Inconnu",
  nov: "Novembre",
  office: "Cabinet",
  oct: "Octobre",
  olderThanFifty: "Avez-vous plus de 50 ans ?",
  optional: "(optionnel)",
  orderForWhichDoctor: "Avec quel médecin avez-vous rendez-vous ?",
  orderForWhichDoctor_relative_male:
    "Avec quel médecin votre proche a-t-il rendez-vous ?",
  orderForWhichDoctor_relative_female:
    "Avec quel médecin votre proche a-t-elle rendez-vous ?",
  orderForWhichHour: "À Quelle heure avez-vous rendez-vous ?",
  orderForWhichHour_relative_male:
    "À Quelle heure votre proche a-t-il rendez-vous ?",
  orderForWhichHour_relative_female:
    "À Quelle heure votre proche a-t-elle rendez-vous ?",
  orderForWho: "Pour quelle(s) personne(s) est la consultation ?",
  otherAllergy: "autre",
  otherDisease: "autre",
  otherOphtalmologicDisease: "Autre",
  page_admin: "administrateur",
  page_check_lastname: "validation-du-nom",
  page_check_password: "validation-du-mot-de-passe",
  page_check_phone: "validation-du-telephone",
  page_home: "maison",
  page_insert_relative: "creation-de-proche",
  page_lobby: "choisir-sa-connexion",
  page_login: "connexion",
  page_nir: "carte-vitale",
  page_not_authorized: "401",
  page_not_found: "404",
  page_order: "questions",
  page_register: "inscription",
  page_register_personal_data: "saisie-des-donnees-personnelles",
  page_reset_password: "reinitialisation-mot-de-passe",
  page_verify: "verification",
  page_verify_phone: "verification-du-mobile",
  page_welcome: "bienvenue",
  panel_for_secretary:
    "Si vous êtes la secrétaire, veuillez saisir le mot de passe administrateur",
  password: "Mot de passe",
  passwordMustBeEightLength:
    "Le mot de passe doit contenir au moins 8 caractères",
  password_validation_char: "8 caractères",
  password_validation_lower: "une lettre minuscule",
  password_validation_number: "un chiffre",
  password_validation_title: "Votre mot de passe doit contenir au moins:",
  password_validation_upper: "une lettre majuscule",
  patientPutError: "Nous n'avons pas pu mettre à jour votre profil",
  patientPutNirError: "Votre numéro de sécurité sociale n'est pas valide",
  patientPutNirSuccess: "Votre numéro de sécurité sociale est valide",
  payloadErrorForm: "Une erreur s'est glissée dans la requête",
  peoplesOlderThanSixtyFive: "les personnes de plus de 65 ans",
  phone: "Téléphone portable",
  phoneExistingErrorForm:
    "Le numéro de téléphone est déjà utilisé pour un autre compte",
  phoneInvalid: "Le téléphone n'est pas valide",
  phoneNotFound: "Le numéro de téléphone n'existe pas dans notre base",
  playerStopped: "Le Lecteur s'est arrêté.",
  pollenAllergy: "allergie au pollen",
  postCallTitle: "`Téléconsultation terminée avec succès`",
  post_call_page: "transition",
  previous: "Retour",
  print: "Imprimer",
  rePrint: "Ré-imprimer",
  rePrintTitle: "Ré-impression",
  rePrintContent:
    "Vous avez déjà envoyé une demande d'impression. Êtes-vous sûr(e) de vouloir ré-imprimer le document ?",
  beSureDocumentsArePrinted:
    "Soyez certain que vos documents ont bien été imprimés ou partagés avec le pharmacien, avant la déconnexion",
  printDocument: "Imprimer les documents",
  printMyCheckup: "Imprimer mon check-up",
  profile_myHistory: "Documents",
  profile_myInformations: "Profil",
  personalInformationsSubtitle: "Informations personnelles",
  profile_myPayments: "Moyens de paiement",
  profile_mySettings: "Paramètres",
  importedDocuments: "Documents importés",
  noImportedDocuments: "Aucun document importé",
  importedDocumentsError: "Impossible de récupérer vos documents importés",
  importedDocumentPreviewError: "Impossible d'afficher ce document",
  provideYourMail:
    "merci de saisir votre email pour le suivi de votre téléconsultation",
  questionForWho: "Pour qui est la consultation ?",
  questionForWhoCheckup: "Pour qui est le check-up ?",
  whoIs: "Qui est ",
  for: "pour ",
  you: "vous",
  questionWhichTime: "A quelle heure avez-vous rendez-vous ?",
  questionWhichWho: "Avec quel médecin avez-vous rendez-vous ?",
  question_step: "les questions pré-consultation",
  reset: "Vider le champ",
  re_enter_phone: "Re-saissir mon numéro de téléphone",
  readerInitialize: "Initialisation...",
  readerSocketGenericError:
    "Une erreur est survenue sur le lecteur de carte, \r\n Veuillez le saisir manuellement",
  readerSocketReadError:
    "Une erreur est survenue lors de la lecture de votre carte",
  readerStopped: "Le lecteur s'est arrêté",
  reading: "\tLecture en cours...",
  reason: "Quel est le motif de votre visite ?",
  reconnectAfterQuestion:
    "Vous allez être reconnecté à votre consultation suite à la saisie des questions pré-consultation",
  redirectAfterQuestion:
    "Vous allez revenir à la dernière étape (RDV ophtalmologiste) suite à la saisie des questions pré-consultation",
  register: "S'inscrire",
  logMeIn: "Me connecter",
  // Split in segments so the emphasized parts can be rendered in bold
  phoneAlreadyExist_1: "Un compte avec le ",
  phoneAlreadyExist_bold1: "numéro",
  phoneAlreadyExist_2: " suivant ",
  phoneAlreadyExist_bold2: "existe déjà",
  phoneAlreadyExist_3: " :",
  phoneDoesNotExist_bold1: "Aucun compte",
  phoneDoesNotExist_1: " trouvé pour ",
  phoneDoesNotExist_bold2: "ce numéro :",
  modifyPhoneNumber: "Modifier le numéro",
  cancelSignupQuestion_1: "Souhaitez-vous ",
  cancelSignupQuestion_bold1: "annuler votre inscription",
  cancelSignupQuestion_2: "ou ",
  cancelSignupQuestion_bold2: "modifier votre numéro",
  cancelSignupQuestion_3: " ?",
  modifyMyNumber: "Modifier mon numéro",
  cancelMySignup: "Annuler l'inscription",
  signMeUp: "M'inscrire",
  registerStep_complementary: "Identifiants",
  registerStep_creation: "Création du compte",
  registerStep_nir: "Carte vitale",
  registerStep_personal: "Informations",
  registerStep_verification: "Téléphone",
  registerTitle: "Je m'inscris",
  register_creation_inProgress: "Création du compte en cours",
  register_validation_inProgress: "Validation du compte en cours...",
  relative: "proche",
  relativesAddedError: "Vos proches n'ont pas pu être ajouté à votre compte",
  relativesAddedSuccess: "Vos proches ont bien été ajoutés",
  relativeUseAnother: (name) => `Le proche utilise un autre ${name}`,
  containsAtLeast: "Contient au moins :",
  tenCharacters: "10 caractères",
  oneLowerCaseLetter: "Une lettre minuscule",
  oneUpperCaseLetter: "Une lettre majuscule",
  oneNumber: "Un Chiffre",
  IhaveReadAndAccept: "J'ai lu et j'accepte ",
  theCGU: "les conditions générales d'utilisation (CGU) ",
  andThe: "et la ",
  newsletterConsentCheckboxLabel:
    "Je souhaite recevoir par e-mail des informations et actualités liées à la santé.",
  cannotLoadTLC: "Impossible de charger la tlc",
  cannotStartTLC: "Impossible de lancer la TLC",
  privacyPolicies: "politique de gestions des données personnelles ",
  ofMedadom: "de Medadom",
  weHaveSendAnSms: "Nous vous avons envoyé un SMS !",
  cannotSendTheSms: "Impossible de renvoyer le SMS",
  cannotCancel: "Impossible d'annuler",
  cannotStartReader: "impossible de lancer le lecteur",
  relativeUseAnotherFirstname: `Le proche utilise un autre Prénom`,
  relativeUseAnotherLastname: `Le proche utilise un autre Nom`,
  cannotRetrievedProfessionalIdentity:
    "Impossible de récupérer l'identité du professionnel de santé",
  cannotRetrieveCompanions: "Impossible de récupérer les accompagnants",
  companion: "ACCOMPAGNANTS",
  cannotCreateCompanion: "Impossible de créer l'accompagnant : ",
  cannotDeleteCompanion: "Impossible de supprimer l'accompagnant",
  cannotGetCompanionsRelationship:
    "Impossible de récupérer les relations des accompagnants",
  updateVerifyMessage: (type: "email" | "sms") => {
    if (type === "email") {
      return "Un email a été envoyé"
    }
    if (type === "sms") {
      return "Un sms a été envoyé"
    }
  },
  price: "Tarif",
  MoreDetails: " En savoir plus...",
  CouldntSendTheCode: "le code n'a pas pu être renvoyé.",
  profilUpdated: "Nous avons bien modifié votre profil",
  passwordIdentical: "Les deux mots de passe sont identiques",
  impossibleToModify: "Impossible de modifier votre",
  RelativeHasBeenUpdated:
    "Nous avons bien modifié les informations de votre proche",
  RelativeModificationImpossible: "Impossible de modifier le proche",
  RelativeHasBeenDeleted: "Nous avons bien supprimé votre proche",
  RelativeDeletionImpossible: "Impossible de supprimer le proche",
  SomethingWentWrong: "Une erreur est survenue",
  WrongVerificationCode: "Le code de vérification est incorrect",
  relaunchPlayer: "Relancer le lecteur",
  removeYourNir: "Veuillez retirer votre carte",
  resendCodeInfo: "En cliquant sur le bouton, un nouvel SMS vous sera envoyé",
  sendItAgain: "Renvoyer le code",
  SignupSuccess: "Vous êtes bien inscrit !",
  RefraichToUpdateInfo:
    "Veuillez rafraichir pour mettre à jour les informations",
  WrongCode: "Le code semble erroné",
  resend_code: "Renvoyer le code par sms",
  resetPasswordRequestIsMadeTitle: (transport: "sms" | "email") =>
    `Si un compte est associé à ce numéro de téléphone, un ${transport} vous a été envoyé`,
  ifMailIsMissing:
    "En l'absence d'email associé au compte, la réinitialisation se fera par SMS",
  resetPasswordTitle:
    "Renseignez votre numéro de téléphone portable pour la réinitialisation de votre mot de passe",
  respiratoryDisease: "maladie respiratoire",
  referrerIsAHealthProfessional:
    "Si vous n'êtes pas en pharmacie, les documents seront envoyés au référent du dispositif",
  scheduledConsultation: "Téléconsultation programmée",
  subscribePlaceholder:
    "Autoriser MEDADOM à vous envoyer des communications par e-mail",
  newsletterNoValidEmailMessage:
    "Pour gérer votre abonnement à la newsletter, vous devez d'abord ajouter une adresse e-mail valide à votre profil.",
  newsletterAddEmailCta: "Ajouter mon e-mail",
  newsletterUnsubscribeConfirmTitle: "Désabonnement de la newsletter",
  newsletterUnsubscribeConfirmText:
    "En vous désabonnant des newsletters, vous <b>ne recevrez plus</b> les informations et actualités liées à la santé.",
  newsletterUnsubscribeConfirmAccept: "Me désabonner",
  newsletterHealthInfo_html:
    "Recevez des <b>informations et actualités</b> liées à la santé.",
  newsletterSubscribeSuccess:
    "Votre abonnement aux newsletters MEDADOM a bien été pris en compte.",
  newsletterUnsubscribeSuccess:
    "Votre désabonnement aux newsletters MEDADOM a bien été pris en compte.",
  newsletterUpdateError:
    "Impossible de mettre à jour votre abonnement à la newsletter",
  doctorBusy: "Tous nos docteurs, sont occupés. Nous sommes navrés.",
  selectDayBirthdate: "Jour",
  selectMonthBirthdate: "Mois",
  selectYearBirthdate: "Année",
  sendCode: "Envoyer le code",
  sendDocumentsToTheReferrer: "Envoyer au pharmacien",
  sent: "Envoyé !",
  sep: "Septembre",
  smsNotReceived: "Je n'ai pas reçu le sms",
  step_page: "etape",
  strabismus: "Strabisme",
  teleconsultationTraining: "Formation à la téléconsultation",
  tlcMade: "Téléconsultations réalisées",
  thanks: "Merci",
  turnThemOff: "Merci de les éteindre avant de continuer.",
  tlcOf: "Téléconsultation du",
  tleOf: "Téléexpertise du",
  thanksForYourAnswers:
    "Merci d'avoir répondu aux questions. Les données renseignées restent confidentielles.",
  thirtyMinutes: "30 min",
  tooltipResetPassword:
    "Un SMS vous sera envoyé avec les informations pour vous connecter",
  tooManyCallsForACustomer:
    "Vous avez déjà effectué une téléconsultation aujourd'hui",
  touch_screen: "Touchez l'écran pour démarrer",
  pinkOctoberCampaign: "Octobre rose. Ensemble contre le cancer du sein.",
  tryAgain: "Relancer le lecteur",
  useCard: "Lancer la téléconsultation",
  useAnother: (name) => `J'utilise au quotidien un autre ${name}`,
  preferedLastname: "Nom utilisé",
  preferedFirstname: "Prénom utilisé",
  IuseAnotherFirstname: "J'utilise au quotidien un autre Prénom",
  IuseAnotherLastname: "J'utilise au quotidien un autre Nom",
  male1stBirthFirstnamePlaceholder: "Jean...",
  male1stFirstnamePlaceholder: "Pierre...",
  BirthLastnamePlaceholder: "Dupont...",
  LastnamePlaceholder: "Durant...",
  female1stBirthFirstnamePlaceholder: "Marie...",
  female1stFirstnamePlaceholder: "Nathalie...",
  unknownBirthLocation: "Lieu de naissance inconnu",
  validate: "Valider",
  verifiedPhoneError: "Le code de vérification est erroné",
  verifiedPhoneSuccess: "Votre téléphone a bien été validé",
  companionIdentification: "Identification accompagnant",
  verifyCallSuccess: "Un SMS vous a été renvoyé.",
  verifyCallSendSuccess: "Vous allez recevoir un appel dans quelques secondes",
  verifyNir: "Vérifiez les numéros avant de passer à l'étape suivante",
  waitingForNirReader: "Recherche du lecteur de carte vitale...",
  answerIn: "La recherche d'une disponibilité peut prendre encore jusqu'à ….",
  tlcExpectedIn: "Téléconsultation prévue dans : ",
  weAreLookingForDoctors:
    "Nous recherchons actuellement un médecin disponible, merci de patienter.",
  weekly: "Cette semaine",
  monthly: "Ce mois-ci",
  yearly: "Cette année",
  total: "Total",
  daily: "Aujourd'hui",
  in: "En",
  welcome: "Bienvenue",
  wichOnes: "Lesquels (sélection multiple possible) ?",
  writeNir: "Inscrivez vos numéros",
  writeVerifyCode: "Entrez le code reçu au ",
  wrongNirLength: "Veuillez saisir 15 chiffres",
  wrongWay:
    "Il semble que vous ne soyez pas arriver ici en suivant le bon chemin",
  yes: "OUI",
  youHaveCancelledCall: "Vous avez annulé la téléconsultation",
  youNeedToRemoveLensesBeforeConsultation:
    "L'examen médical nécessite un retrait de vos lentilles la veille de la téléconsultation.",
  youWillLaunchATLC: "Vous allez lancer une demande de téléconsultation",
  yourDocuments: "Vos Documents",
  yourPharmaAccount: "Votre compte pharmacie",
  yourWaitingTime: "Votre temps d'attente :",
  estimatedWaitingTime: "Temps d'attente : ",
  // tutorial
  take: "Prenez",
  itIsDone: "C'est fait !",
  finish: "Terminer",
  iTurnOff: "J'ai éteint",
  turnOffDevice_html: (
    deviceName: string,
  ) => `<b>Glisser le curseur pour éteindre ${deviceName}</b>
    <br />
    (position OFF)`,
  turnOnDevice_dermatoscope_html: `Glisser <b>le curseur jusqu'au bout </b> pour allumer
    <br />
    (position LED)`,
  turnOnDevice_otoscope_html: `Glisser <b>le curseur jusqu'au bout </b> pour allumer
    <br />
    (position LED2)`,
  deviceWaitingMessage: `L'appareil peut mettre <b>quelques secondes à être détecté</b>`,
  seemsDeviceNotOn: (
    deviceName: string,
  ) => `Il semblerait que ${deviceName} ne fonctionne pas
    ou ne soit pas branché`,
  lightDevice_html: `Glisser <b>la molette de luminosité au maximum</b>`,
  focusDevice_html: `<b>Ajuster la netteté de l'image</b> si besoin
    <b> en déplaçant la molette grise</b>`,
  isNotTurnOn: "n'est pas branché",
  inUsing: "Utilisation en cours",
  useVideoDevice_html: (deviceNaming: string) => {
    if (deviceNaming === "otoscope")
      return `Placer <b>votre pouce sur la molette grise</b> puis <b>introduire l'embout</b> dans l'oreille`
    if (deviceNaming === "dermatoscope")
      return "<b>Placer l'embout sur la zone à montrer</b>"
  },
  warning: "Attention",
  RelativeAddedSuccessfully: "Bravo, vous avez ajouté un proche",
  modalContent_changePatientInformation_html:
    "Si vous souhaitez téléconsulter pour <b>une autre personne</b>, vous<br/> devez <b>ajouter un proche</b> lors de votre prochain parcours de<br/>téléconsultation <b>et non modifier les données</b>",
  modifyDatas: "Modifier les données",
  datas_and_consent_title: "Données et consentement",
  datas_and_consent_point_1:
    "Je confirme mon libre choix à la téléconsultation et qu'elle ne m'est imposée par aucun contexte particulier",
  datas_and_consent_point_2:
    "J'accepte la collecte de mes données personnelles nécessaires :",
  datas_and_consent_point_2_checkbox_1:
    "à mon parcours de soins (gestion du dossier administratif, médical, facturation, sms)",
  datas_and_consent_point_2_checkbox_2:
    "à l'établissement de statistiques anonymes et à l'amélioration du produit dans le respect de la réglementation applicable",
  datas_and_consent_point_3:
    "Medadom et ses sous-traitants protègent vos données de santé. Pour plus d'informations ainsi que les éventuels liens d'intérêts, voir",
  datas_and_content_point_3_ref: " la politique de confidentialité",
  IConfirmAndContinue: "Je confirme et continue",
  verifyEmail:
    "Pour confirmer le changement, entrez le code reçu par email à l'adresse suivante",
  add: "Ajouter",
  IConfirmmyConsentDataChoice:
    "Je confirme mon libre choix à la téléconsultation et accepte la collecte de mes données personnelles.",
  IConfirmMyConsentDataChoiceExempte:
    "Je confirme avoir pris connaissance des CGU et mon libre choix à la téléconsultation, et j'accepte la collecte de mes données personnelles",
  verifyPhone:
    "Pour confirmer le changement, entrez le code reçu au numéro suivant",
  addCarer: "Ajouter un accompagnant",
  addingCarer: "Ajout d'un accompagnant",
  addProfessional: "Ajouter un professionnel",
  proOrReferent: "Un professionnel de santé ou référent",
  aRelative: "Un proche",
  asCarer: "En tant qu'accompagnant,",
  iConsentTo: "je m'engage à",
  keepInformationConfidential:
    "garder confidentielles les informations échangées",
  duringTLC: "lors de la téléconsultation",
  iCommit: "Je m'engage",
  insertAdminEmail:
    "Par mesure de sécurité, merci de demander à l'administrateur du dispositif de téléconsultation d'indiquer son email",
  IsaPro: "Est-ce un professionnel de santé ?",
  isCarerInTheList: "L'accompagnant est-il dans la liste ?",
  exemplePro: "(pharmacien, infirmier, ...)",
  whichRelativeIsCaringYou: "Quel proche vous accompagne ?",
  whichProfessionalIsCaringYou: "Quel professionnel vous accompagne ?",
  whichProfessionalIsCaringYou_relative:
    "Quel professionnel accompagne votre proche ?",
  whatIsRelationship: "Quel est le lien de parenté de l'accompagnant ?",
  confirmRemoveCarer: "Vous allez supprimer l'accompagnant suivant :",
  incorrectFieldAdminEmail: "Le champ est incorrect",
  forMoreSecurity: "Pour plus de sécurité",
  insertFirstnameCarer: "Entrez le prénom de l'accompagnant",
  insertLastnameCarer: "Entrez le nom de famille de l'accompagnant",
  insertPhoneCarer: "Entrez le numéro de téléphone de l'accompagnant",
  insertRpps: "Entrez le RPPS du professionnel de santé accompagnant",
  rpps: "11 chiffres",
  addPro: `Souhaitez-vous ajouter ce professionnel ?`,
  healthPro: "Professionnel de santé",
  HealthProfessional: "Professionnel de santé",
  Referer: "Référent",
  delete: "Supprimer",
  otherCarer: "Autre accompagnant",
  noCarer: "Aucun accompagnant",
  ImCaredForThisTlc_relative: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "Mon proche peut-elle être accompagnée lors de la téléconsultation ?"
      : "Mon proche peut-il être accompagné lors de la téléconsultation ?",
  ImCaredForThisTlc: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "Puis-je être accompagnée lors de la téléconsultation ?"
      : "Puis-je être accompagné lors de la téléconsultation ?",
  carerExplanationTitle_html:
    "<b>Qui peut m'accompagner</b> lors d'une téléconsultation ?",
  carerExplanationIntro_html:
    "Vous avez <b>le droit d'être assisté</b> par un professionnel de santé ou par un proche pour réaliser une téléconsultation.",
  carerExplanationRelativeBody_html:
    "Vous pouvez nommer <b>l'un de vos proches</b> comme personne de confiance. Par exemple votre conjoint(e), un proche parent, etc...",
  carerExplanationProfessionalBody_html:
    "Vous pouvez aussi être accompagné par <b>un professionnel de santé</b> faisant partie de votre parcours de soins.",
  carerExplanationRole_html:
    "L'accompagnant <b>vous soutient</b>, <b>vulgarise les questions</b> du médecin et <b>complète les informations</b> pour améliorer l'échange. Il est tenu de <b>respecter la confidentialité</b> des téléconsultations.",

  whoIsCaringYouForTheTLC: "Qui vous accompagne pour cette téléconsultation ?",
  whoIsCaringYouForTheTLC_relative:
    "Qui accompagne votre proche pour cette téléconsultation ?",
  whoIsCaringYou: "Quelle personne vous accompagne ? ",
  whoIsCaringYou_relative: "Quelle personne accompagne votre proche ?",
  required: "Cette donnée est obligatoire",
  passwordHasNotBeenChangedSince_html: (days: number) => {
    if (days <= 0)
      return `<div>Votre mot de passe a <b>expiré</b>, cela fait plus de ${Math.abs(days)} ${Math.abs(days) <= 1 ? "jour" : "jours"} que vous ne l'avez pas modifié. Pour plus de <b>sécurité</b>, veuillez le modifier <b>dès à présent</b>.</div>`
    if (days === 1)
      return `<div>Votre mot de passe <b>expire demain.</b> Pour des raisons de <b>sécurité</b>, nous vous encourageons à le renouveler dès à présent.</div>`
    return `<div>Votre mot de passe <b>expire dans ${days} jours.</b> Pour des raisons de <b>sécurité</b>, nous vous encourageons à le renouveler dès à présent.</div>`
  },
  later: "Plus tard",
  modifyPassword: "Modifier mon mot de passe",
  uneligibleTitle:
    "La téléconsultation n'est pas possible dans les cas suivants :",
  teleexpertiseIneligibleTitle: "La téléexpertise n'est pas possible dans les cas suivants :",
  lessthan3yearOld: "Enfants de moins de 3 ans",
  unaccompaniedMinors: "Mineurs non accompagnés",
  ExtendedSickLeave: "Prolongation d'arrêt de travail ou accident de travail",
  fitnessCertificate: "Certificat d'aptitude (sport, crèche)",
  PrescriptionOfPsychoactive:
    "Prescription de traitements psychoactifs de dépendance",
  IhaveUnderstood: "j'ai compris et je continue",
  photoOfBurn: "(photos de la brûlure, …)",
  photoOfJoins: "(photos des articulations, ...)",
  photoOfLesion: "(photos de la lésion, …)",
  photoOfThroat: "(photos de la gorge, …)",
  photoOfTheEye: "(photos de l'oeil, …)",
  photoOfSting: "(photos de la piqûre, ...)",
  PrescriptionToBeRenewed: "(ordonnance à renouveler, traitement, ...)",
  analysisResults: "(résultats d'analyse, …)",
  mister: "M.",
  miss: "Mme",
  sendBackTheCode: "RENVOYER LE CODE DANS",
  scanTogetSupport:
    "Pour accéder au Centre d'aide MEDADOM, merci de scanner ce QR Code :",
  youCanContactSupport: "Vous pouvez également contacter le support :",
  mondayToSaturday: "Du lundi au samedi, de 9h à 19h30",
  atSupportNumber: "au 01 86 65 55 15",

  noDoctorOnline: "Aucun médecin en ligne",
  doctorsNearby: "Médecin(s) à proximité",
  doctorsOnline: "Médecin(s) en ligne",
  consultNowWithDoctorOrChoseHim:
    "Téléconsultez avec le prochain médecin disponible",
  consultNowWithDoctor: "Téléconsulter avec le prochain médecin disponible",
  teleconsultNow: "Téléconsulter maintenant",
  choseDoctorWithoutGuarantee:
    "Choisir mon médecin sans garantie de disponibilité immédiate",
  doctorGuaranteeWarning:
    "La disponibilité immédiate du médecin sélectionné n'est pas garantie. Pour réduire votre temps d'attente, nous vous conseillons d'élargir votre demande à tous les médecins disponibles.",
  expandMyRequest: "Élargir ma demande",
  teleconsultWithChosenDoctor: "Téléconsulter avec le médecin séléctionné",

  weight: "Ajoutez votre poids",
  skipStep: "Passer l'étape",
  indicateTreatingDoctorModal: "Indiquez votre médecin traitant pour faciliter la continuité de vos soins.",
  enterMyDoctor: "Saisir mon médecin",
  addYourWeight: "Ajoutez votre poids",
  addYourHeight: "Ajoutez votre taille",
  addYourTemperature: "Ajoutez votre température",
  takeYourTemperature: "Merci de prendre votre température",
  kilogram: "kg",
  celsius: "° C",
  iTookMyTemperature: "J'ai pris ma température",
  unableToProcessVideo: "Nous ne sommes pas en capacité de jouer la vidéo",
  choosePasswordRenewMethod:
    "Choissisez une méthode pour recevoir le lien permettant la réinitialisation de votre mot de passe",
  addYourSaturation: "Ajoutez votre saturation",
  takeYourSaturation: "Merci de prendre votre saturation en oxygène",
  takeYourTension: "Merci de prendre votre pression artérielle",
  addYourTension: "Indiquez votre pression artérielle",
  searchADoctor: "Rechercher un médecin",
  iTookMyTension: "J'ai pris ma pression artérielle",
  iTookMySaturation: "J'ai pris ma saturation",
  noResultBeMorePrecise:
    "Aucun résultat. Merci d'affiner vos critères de recherche",
  toReduceWaitingTime:
    "Pour réduire votre temps d'attente, nous vous conseillons d'élargir votre demande à tous les médecins disponibles.",
  wrongSaturationValue: "la saturation semble erronée",
  wrongTemperatureValue: "la température semble erronée",
  correctYourVitalsValue: (vitalType) =>
    `Veuillez corriger votre ${vitalType === "temperature" ? "temperature," : ""} ${vitalType === "spo2" ? "saturation," : ""} la valeur saisie semble anormale.`,
  or: "OU",
  byCard: "Par carte bancaire",
  payByCard: "Renseigner ma carte",
  payByContactlessPayment: "Paiement sans contact",
  choosePaymentMethod: "Choisissez votre méthode de paiement",
  pay: "Payer",
  payAndLaunchTLC: "Payer et lancer ma demande",
  estimatedTlcWaitingTime: "Temps d'attente estimé : ",
  putYourHeadsetAndSpeak:
    "Mettez le casque (si disponible) et parlez dans le micro, la jauge bouge-t-elle ?",
  testTheHardware: "Tester le matériel",
  doYouSeeYourselfOnScreen: "Est-ce que votre image apparaît à l'écran ?",
  yourCameraDoesNotWork: "Votre caméra ne semble pas fonctionner",
  beReadyForConsultation: "Soyez prêt pour votre consultation",
  restartDiagnostic: "relancer le test",
  pharmacyPleaseDo: "Pharmacie, merci de bien vouloir : ",
  youDetectedAnIssue: "Vous avez signalé un problème",
  cameraDoesNotWork: "La caméra ne semble pas fonctionner",
  microDoesNotWork: "Le micro ne semble pas fonctionner",
  pleaseContactTheReferent: "Merci de vous rapprocher du référent de la borne.",
  verifyAccessTo: (mediaDevice: "video" | "audio") =>
    `Vérifier l'accès ${mediaDevice === "audio" ? "au micro" : "à la caméra"}`,
  restartDevice: (mediaDevice: "video" | "audio") =>
    `Débrancher et rebrancher ${mediaDevice === "audio" ? "le câble du casque" : "le câble de la caméra"}`,
  demoVersion: "VERSION DE DÉMO",
  continueAnyway: "Continuer quand même vers la consultation",
  cameraAndMicDoesNotWork:
    "Le micro et/ou la caméra ne semblent pas fonctionner.",
  personalize: "Personnaliser ...",
  toASet: "à un ensemble de",
  obligatoryPurposes: "finalités obligatoires",
  forMyParkour:
    "pour mon parcours de soins (gestion de mon dossier administratif/médical, facturation et envoi de SMS/e-mails)",
  secondaryPurposes: "finalités secondaires",
  likeDoingStatistic:
    "comme l'établissement de statistiques anonymes ou l'amélioration du service client",
  statisticsEstablishment: "établissement de statistiques anonymes",
  clientServiceImprovment: "amélioration du service client",
  platformServiceImprovement:
    "amélioration des services proposés par la plateforme (entraînement de modèles statistiques pour l'IA...)",
  activityPromotion:
    "promotion des activités de Synapse et information des patients",
  partnersFollowing: "suivi des partenariats",
  medadomAndPartners:
    "MEDADOM et ses sous-traitants protègent vos données de santé",
  forMoreInformation:
    "Pour plus d'informations ainsi que les éventuels liens d'intérêts, voir la",
  privacyPolicy: "politique de protection des données personnelles",
  IConfirmMyConsent:
    "Je confirme mon libre choix à la téléconsultation et qu'elle ne m'est imposée par aucun contexte particulier",
  IConfirmDataConsent: "J'accepte la collecte de mes données personnelles.",
  consultingDoctors: "Médecins téléconsultants chez Medadom",
  firstOnsiteAddress: "Adresse d'exercice principale : ",
  listOfHealthProfessionals: "Liste des professionnels de santé Medadom",
  createPaymentError: "Une erreur est survenue lors de la création du paiement",
  paymentRefused: "Paiement refusé",
  retryLater: "Veuillez réessayer dans quelques instants.",
  ifErrorStillOccur: "Si le problème persiste, veuillez contacter l'administrateur du dispositif.",
  enterAdminEmail: "Entrez l'email de l'administrateur",
  enterAdminPassword: "Entrez le mot de passe de l'administrateur",
  associateKiosk: "Configurer le paiement sans contact",
  associateKioskForContactlessPayment: "Smartphones jumelés pour la réception des paiements sans contact",
  associateNewPhone: "jumeler un autre smartphone",
  generatingQRCode: "Génération du QR code...",
  associatePaymentTerminal: "QR code de jumelage",
  scanQRCodeWithContactlessPaymentApp: "Suivez les instructions dans l’app « Med’Pay Pro » et scannez le QR code pour jumeler votre smartphone.",
  timeRemaining: "Temps restant",
  qrCodeExpired: "QR code expiré, veuillez le regénérer",
  qrCodeRefreshIn: "Actualisation du QR code dans",
  regenerateQRCode: "Regénérer le QR code",
  deviceModels: "Modèles de lecteurs",
  downloadMedadomPaymentTerminalApp: 'QR code de téléchargement de l\'app « Med’Pay Pro »',
  scanQRCodeToDownloadApp: "Pour activer le paiement sans contact sur votre dispositif, commencez par télécharger l'app « Med’Pay Pro » sur votre smartphone en scannant le QR code ci-dessous, puis suivez les étapes indiquées dans l'app.",
  confirmDeleteDeviceModel: "Confirmer la suppression",
  confirmDeleteDeviceModelMessage: "Êtes-vous sûr de vouloir supprimer le terminal suivant ?",
  deleteDeviceModelWarning: "Le jumelage avec le smartphone suivant sera supprimé :",
  iHaveDownloadedTheApp: "J'ai téléchargé l'app",
  waitingContactlessPaymentInfo:
    "Payer par carte bancaire sur le terminal du membre de l'équipe.",
  waitingContactlessPaymentButton: "En attente du paiement",
  useAnotherPaymentMethodInfo:
    "Merci de réessayer ou d’utiliser un autre moyen de paiement.",

  ageNotInRange: "Votre âge ne fait pas partie des tranches d'âges prévues",
  forThisCourse: "pour ce parcours.",
  courseReservedFor:
    "Ce parcours est réservé aux personnes dont l'aĝe se situe dans l'une des tranches suivantes :",
  eighteenToTwentyFiveYears: "18 à 25 ans",
  fortyFiveToFifty: "45 à 50 ans",
  sixtyToSixtyFive: "60 à 65 ans",
  seventyToSeventyFive: "70 à 75 ans",
  thanksForYourInterest:
    "Nous vous remercions de votre intérêt et vous invitons à changer de parcours.",

  the: "Le",
  prevention: "Bilan Prévention",
  pharmacist: "Pharmacien(ne)",
  pharmacistActionRequired: "Action requise du pharmacien",
  pharmacistEmailPrompt:
    "Merci de demander au pharmacien de saisir l'adresse e-mail de connexion de cette borne (e-mail administrateur)",
  pharmacistEmailMismatch:
    "L'adresse e-mail saisie ne correspond pas à l'e-mail administrateur de cette borne.",
  preventionPharmacistConfirmTitle: "Avez-vous bien confirmé qu'un pharmacien sur place est disponible ?",
  preventionPharmacistConfirmYes: "Oui, un pharmacien est disponible",
  preventionPharmacistConfirmNo: "Non, choisir un autre parcours",
  preventionSurveyEndTitle: "Merci pour vos réponses !",
  preventionSurveyEndButton: "Valider le questionnaire",
  preventionDocumentGenerationTitle: "Merci !",
  preventionDocumentGenerationText_html:
    "Votre document est <b>en cours</b> de génération...",
  pharmacistEndTitle: "Merci pour vos réponses !",
  pharmacistEndPrintInfo_html:
    "Vous pouvez imprimer les documents et vous rendre vers le pharmacien disponible pour votre bilan de prévention",
  // finishAndSendDocuments: "Terminer et envoyer mes documents",
  pharmacistEndSentTitle: "Documents envoyés",
  pharmacistEndSentMessage:
    "Vos documents ont bien été transmis. Vous pouvez les imprimer auprès de votre pharmacien.",
  isAProgramOfMinistry:
    "est un dispositif du Ministère de la Santé et de la Prévention qui vous invite à",
  takeStockHealth: "faire le point sur votre santé.",
  itIs: "Il est",
  hundredPourcentFree: "100 % pris en charge",
  withoutAdvance: "sans avance de frais.",

  youreGonna: "Vous allez",
  fillAForm: "remplir un questionnaire",
  aboutFortyQuestion: "d'une quarantaine de question et",
  lessThanTenMinutes: "environ 10 minutes suffisent",
  toAnswer: "pour y répondre",

  nextYouWill: "Vous serez ensuite",
  putInTouch: "mis(e) en relation avec un professionnel de santé",
  forAnExchange: "pour un échange privilégié d'une durée de 30 à 40 min.",
  youWillBenefit: "L'entretien se fera avec le pharmacien pour un échange privilégié. Vous bénéficierez de",
  healthAdvice: "conseils de santé personnalisés.",

  objectiveOf: "L'objectif du questionnaire",
  isSimple: "est simple :",

  getInitialAdvice: "Bénéficier de premiers conseils pour agir sur votre santé",
  becomeAwareOf: "Prendre conscience de vos habitudes de vie",
  acknowledgeThings:
    "Prendre connaissance des thématiques qui pourront être abordées",

  youCantDoPrevention: "Vous n'êtes pas éligible au bilan prévention",
  changeGender: "Changer de civilité",
  // Choix du spécialiste
  chooseSpecialist: "Choisissez un parcours",
  generalistDoctor: "Médecine générale",
  dermatologist: "Dermatologie",
  teleexpertise: "Avis dermatologique",
  pathwayLabelGeneralist: "Parcours Médecine générale",
  pathwayLabelDermatology: "Parcours Dermatologie",
  pathwayLabelCheckup: "Parcours Check-up santé",
  pathwayLabelPrevention: "Parcours Bilan Prévention",
  chooseSpecialistCheckupDelay: "Parcours de 5 minutes",
  dermatologyCheckupDelay: "Télé-expertise en 48 heures",
  returnHomePage: "revenir à l'accueil",
  // Dermatologie
  dermatoIUnderstand: "J'ai bien compris le parcours",
  dermatoRecapTitle: "Résumé de votre demande",
  dermatoRecapSubtitle: "Vérifiez vos informations avant de continuer",
  dermatoRecapReason: "Motif de consultation",
  dermatoRecapMotif: "Motif",
  dermatoRecapSubReason: "Sous-motif",
  dermatoRecapBodyZones: "Zone(s) concernée(s)",
  dermatoRecapSymptoms: "Autre(s) Symptôme(s)",
  dermatoRecapChronicIllness: "Maladie(s) chronique(s)",
  dermatoRecapOperations: "Opération(s) passée(s)",
  dermatoRecapAllergies: "Allergie(s) connue(s)",
  dermatoRecapMedications: "Prise de médicament(s) régulière",
  dermatoRecapDermHistory: "Antécédents dermatologiques",
  dermatoRecapFamilyCancer: "Antécédents familiaux de cancer de la peau",
  dermatoRecapRecentTravel: "Voyage récent (-6 mois)",
  dermatoRecapZoneEvolution: "Évolution récente de la zone concernée",
  dermatoRecapProblemDuration: "Ancienneté du problème de peau",
  dermatoRecapZoneEvolutionDuration: "Évolution significative depuis",
  dermatoRecapLastControl: "Dernière consultation dermatologique",
  dermatoRecapSunExposure: "Exposition solaire fréquente",
  dermatoRecapSunburnBefore20: "Coups de soleil avant 20 ans",
  dermatoRecapPhototype: "Phototype",
  dermatoRecapPatientDetails: "Vos précisions",
  teleexpertiseConsentTitle: "Consentement",
  teleexpertiseConsentSubtitle:
    "Le patient et le pharmacien doivent valider la demande avant envoi",
  teleexpertisePharmacistConsent:
    "Je certifie être ou agir sous la responsabilité du pharmacien titulaire de l'officine et solliciter une demande de téléexpertise.",
  teleexpertiseInformationConsent:
    "Je confirme, en tant que professionnel de santé, avoir vérifié les informations et valider l'envoi de la demande.",
  teleexpertisePatientConsent:
    "Je confirme que le patient a pris connaissance de la demande de téléexpertise et consent à son envoi.",
  teleexpertiseConsentSubmit: "Envoyer la demande",
  dermatoGeneralistTitle: "Médecin généraliste",
  dermatoSpecialistTitle: "Dermatologue",
  dermatoSpecialistDescription: "Le médecin pourra solliciter directement <b>par écrit</b> l'avis d'un <b>dermatologue</b>, qui reviendra sous <b>48 heures ouvrées</b> avec son avis.",
  dermatoPharmaTitle: "Votre demande a bien été transmise.",
  dermatoPharmaDescription: "Vous serez <b>averti(e) par SMS et email</b> dès que votre avis dermatologique sera disponible. Il vous suffira de <b>revenir en pharmacie</b> pour le récupérer directement sur ce dispositif.",
  dermatoSelectedDocumentsTitle:
    "Utilisez votre smartphone pour prendre une photo de la zone concernée",
  dermatoTakePhoto: "prendre une photo",
  dermatoSkipStep: "Passer l'étape",
  dermatoReasonTitle: "Quel est le motif de votre consultation ?",
  dermatoReasonTitle_relative_male:
    "Quel est le motif de consultation en dermatologie de votre proche ?",
  dermatoReasonTitle_relative_female:
    "Quel est le motif de consultation en dermatologie de votre proche ?",
  dermatoReasonPimples: "Boutons, acné, points noirs",
  dermatoReasonItching: "Démangeaisons",
  dermatoReasonRash: "Éruptions cutanées",
  dermatoReasonMoles: "Grains de beauté et taches suspectes",
  dermatoReasonTreatmentFollowup: "Suivi de traitement",
  dermatoReasonOther: "Autres",
  dermatoSymptomsTitle: "Quels autres symptômes avez-vous ?",
  dermatoSymptomFever: "Fièvre",
  dermatoSymptomSweat: "Sueur",
  dermatoSymptomPain: "Douleurs",
  noSymptoms: "Aucun",
  otherSymptoms: "Autre",
  dermatoBodyZoneTitle: "Où se situent les zones concernées ?",
  dermatoBodyZoneFront: "À l'avant du corps",
  dermatoBodyZoneBack: "À l'arrière du corps",
  dermatoBodyZoneWholeBody: "Tout le corps",
  dermatoBodyZoneFace: "Visage",
  dermatoBodyZoneHead: "Tête",
  dermatoBodyZoneNeck: "Cou",
  dermatoBodyZoneHands: "Main(s)",
  dermatoBodyZoneFeet: "Pied(s)",
  dermatoBodyZoneChest: "Torse",
  dermatoBodyZoneBackBody: "Dos",
  dermatoBodyZoneArms: "Bras",
  dermatoBodyZoneLegs: "Jambe(s)",
  dermatoBodyZoneArmpits: "Aisselles",
  dermatoBodyZoneGenitals: "Parties génitales",
  dermatoBodyZoneButtocks: "Fesses",
  dermatoBodyZoneShoulders: "Epaule(s)",
  dermatoBodyZoneOther: "Autre",
  dermatoPhototypeTitle: "Quel est votre phototype ?",
  dermatoPhototypeTitle_relative_male:
    "Quel est le phototype de votre proche ?",
  dermatoPhototypeTitle_relative_female:
    "Quel est le phototype de votre proche ?",
  phototype1_html:
    "<span style='font-size:18px; line-height: 28px; display: block;'><b>Coups de soleil :</b> systématiques<br /><b>Bronzage :</b> inexistant</span>",
  phototype2_html:
    "<span style='font-size:18px; line-height: 28px; display: block;'><b>Coups de soleil :</b> fréquents<br /><b>Bronzage :</b> très léger</span>",
  phototype3_html:
    "<span style='font-size:18px; line-height: 28px; display: block;'><b>Coups de soleil :</b> occasionnels<br /><b>Bronzage :</b> graduel</span>",
  phototype4_html:
    "<span style='font-size:18px; line-height: 28px; display: block;'><b>Coups de soleil :</b> assez rares<br /><b>Bronzage :</b> rapide</span>",
  phototype5_html:
    "<span style='font-size:18px; line-height: 28px; display: block;'><b>Coups de soleil :</b> rares<br /><b>Bronzage :</b> important</span>",
  phototype6_html:
    "<span style='font-size:18px; line-height: 28px; display: block;'><b>Coups de soleil :</b> exceptionnels<br />voire inexistants</span>",
  phototype1: "Coups de soleil : systématiques, Bronzage : inexistant",
  phototype2: "Coups de soleil : fréquents, Bronzage : très léger",
  phototype3: "Coups de soleil : occasionnels, Bronzage : graduel",
  phototype4: "Coups de soleil : assez rares, Bronzage : rapide",
  phototype5: "Coups de soleil : rares, Bronzage : important",
  phototype6: "Coups de soleil : exceptionnels voire inexistants",
  dermatoVideoCaptureTitle:
    "Merci de prendre en photo la zone concernée avec le dermatoscope",
  dermatoVideoCaptureSkip: "Passer l'étape",
  dermatoVideoCaptureReady: "Je suis prêt à prendre la photo",
  dermatoVideoCaptureInProgress: (seconds: number) =>
    `Prise de la photo dans ${seconds} seconde${seconds > 1 ? "s" : ""}`,
  dermatoVideoCaptureRetake: "Reprendre la photo",
  dermatoVideoCaptureShooting: "Prise des photos en cours...",
  dermatoVideoCaptureSelectBest:
    "Veuillez sélectionner une photo <u>nette</u> et <u>centrée</u> montrant clairement la zone concernée",
  dermatoVideoCaptureSelectRetake: "Reprendre",
  dermatoVideoCaptureSelectValidate: "Valider la photo",
  dermatoVideoCaptureSend: "Envoyer la photo",
  dermatoVideoCaptureEnsureVisible:
    "Veillez à ce que la zone concernée soit bien visible sur la photo",
  dermatoVideoCaptureSending: "Envoi de la photo...",
  dermatoVideoCaptureSuccess:
    "Vous pouvez passer à la suite ou reprendre une photo",
  dermatoVideoCaptureError: "Erreur lors de l'envoi de la photo",
  dermatoVideoCaptureTakeAnother: "Ajouter une nouvelle photo",
  dermatoVideoCapturePhotoName: "Photo dermatoscope",
  dermatoVideoCaptureTurnOffDevice: "Éteignez l'appareil pour passer à la suite",
  dermatoVideoCaptureTutorialLabel: "Tutoriel",
  dermatoVideoCaptureVideoFeedLabel: "Retour vidéo",
  dermatoVideoCaptureTakeAndTurnOnDevice: "Prenez et allumez l'outil D (dermatoscope)",
  dermatoQuestionsTitle: "Merci de répondre aux éléments suivants",

  dermatoLastControl: "Dernière consultation dermatologique",
  dermatoLastControl_relative_male:
    "Dernière consultation dermatologique de votre proche",
  dermatoLastControl_relative_female:
    "Dernière consultation dermatologique de votre proche",
  dermatoLastControlMore3Years: "+3 ANS",
  dermatoLastControlLess3Years: "-3 ANS",
  dermatoSunExposure:
    "Avez-vous une exposition solaire fréquente ?<br/><i>(travail en extérieur, loisir en extérieur, ...)</i>",
  dermatoSunExposure_relative_male:
    "Votre proche a-t-il une exposition solaire fréquente ?<br/><i>(travail en extérieur, loisir en extérieur, ...)</i>",
  dermatoSunExposure_relative_female:
    "Votre proche a-t-elle une exposition solaire fréquente ?<br/><i>(travail en extérieur, loisir en extérieur, ...)</i>",
  dermatoSunProtection: "Utilisez-vous des protections solaires ?",
  dermatoSunProtection_relative_male:
    "Votre proche utilise-t-il des protections solaires ?",
  dermatoSunProtection_relative_female:
    "Votre proche utilise-t-elle des protections solaires ?",
  dermatoSunburnBefore20: "Avez-vous eu des coups de soleil avant 20 ans ?",
  dermatoSunburnBefore20_relative_male:
    "Votre proche a-t-il eu des coups de soleil avant 20 ans ?",
  dermatoSunburnBefore20_relative_female:
    "Votre proche a-t-elle eu des coups de soleil avant 20 ans ?",
  dermatoAnamnesisQuestionsTitle:
    "Êtes-vous concerné(s) par un des cas suivants ?",
  dermatoHistory:
    "Antécédents dermatologiques<br/><i>(ex: infections, cancer, dermatite...)</i>",
  dermatoHistory_relative_male:
    "Votre proche a-t-il des antécédents dermatologiques ?",
  dermatoHistory_relative_female:
    "Votre proche a-t-elle des antécédents dermatologiques ?",
  dermatoHistoryDetailsTitle: "Quel(s) antécédent(s) dermatologique(s) ?",
  dermatoHistorySkinCancer:
    "Cancer de la peau (mélanome, carcinome) — personnel ou familial",
  dermatoHistoryEczema: "Eczéma (dermatite atopique)",
  dermatoHistoryPsoriasis: "Psoriasis",
  dermatoHistoryAcne: "Acné",
  dermatoHistoryChronicHives: "Urticaire chronique",
  dermatoHistoryHerpesZona: "Herpès / zona récidivant",
  dermatoHistoryRosacea: "Rosacée",
  dermatoFamilyCancer: "Antécédents familiaux de cancer de la peau",
  dermatoFamilyCancer_relative_male:
    "Votre proche a-t-il des antécédents familiaux de cancer de la peau ?",
  dermatoFamilyCancer_relative_female:
    "Votre proche a-t-elle des antécédents familiaux de cancer de la peau ?",
  dermatoRecentTravel: "Voyage récent<br/><i>(- de 6 mois)</i>",
  dermatoRecentTravel_relative_male:
    "Votre proche a-t-il effectué un voyage récent<br/><i>(- de 6 mois)</i> ?",
  dermatoRecentTravel_relative_female:
    "Votre proche a-t-elle effectué un voyage récent<br/><i>(- de 6 mois)</i> ?",
  dermatoZoneEvolution: "La zone concernée a-t-elle évolué récemment ?",
  dermatoZoneEvolution_relative_male:
    "La zone concernée de votre proche a-t-elle évolué récemment ?",
  dermatoZoneEvolution_relative_female:
    "La zone concernée de votre proche a-t-elle évolué récemment ?",
  dermatoProblemDurationTitle: "Apparition de votre problème dermatologique",
  dermatoProblemDuration:
    "Depuis combien de temps avez-vous ce problème de peau ?",
  dermatoZoneEvolutionDurationTitle: "Évolution de la zone",
  dermatoZoneEvolutionDuration:
    "Depuis quand observez-vous une évolution significative de la zone ?",
  dermatoDurationLessThan48h: "Moins de 48 h",
  dermatoDuration2To7Days: "Entre 2 et 7 jours",
  dermatoDuration1WeekTo1Month: "1 semaine à 1 mois",
  dermatoDuration1To6Months: "1 à 6 mois",
  dermatoDurationMoreThan6Months: "Plus de 6 mois",
  dermatoOverviewPart1_html: "Une <b>demande de téléexpertise</b> sera transmise à un <b>dermatologue</b>, qui fournira un avis sous <b>48 heures ouvrées</b>.",
  dermatoOverviewInfoTitle: "Votre parcours dermatologique",
  dermatoOverviewInfoItem1_html: "Mise à disposition d'<b>un avis détaillé</b> d'un dermatologue",
  dermatoOverviewInfoItem2_html: "<b>Aucune délivrance d'ordonnance</b> ; en cas de besoin, il faudra téléconsulter un médecin ou consulter en présentiel",
  dermatoOverviewInfoItem3_html: "Si nécessaire au vu de votre pathologie, <b>un rendez-vous en présentiel</b> peut être recommandé",
  dermatoOverviewPart2_html: "Vous recevrez cet avis dermatologique et serez notifié(e) par <b>SMS et email</b>. Vous pourrez venir le récupérer <b>sur place</b>, sur le dispositif, éventuellement accompagné(e) du pharmacien.",
  pharmacistMustBeHere: "Un professionnel de santé est-il présent avec vous ?",
  pharmacistMustBeHereSubtitle_html: "L'assistance d'un professionnel de santé, comme un pharmacien, <b>est obligatoire</b> pour <b>poursuivre le parcours</b>.",
  pharmacistMustBeHereProfessionalPresent: "Oui, un professionnel est présent",
  pharmacistMustBeHereBackToPathway: "Non, revenir au choix du parcours",
  pharmacistInfoTitle: "Informations du pharmacien",
  pharmacistRppsTitle: "Recherchez votre numéro RPPS",
  pharmacistRppsPlaceholder: "Saisir votre numéro RPPS",
  pharmacistRppsModify: "Modifier",
  pharmacistFinessLabel: "FINESS de facturation de l'etablissement",
  pharmacistFinessPlaceholder: "9 chiffres — différent du FINESS juridique",
  pharmacistFinessLengthError: "Le FINESS de facturation doit contenir exactement 9 chiffres",
  pharmacistRppsLengthError: "Le RPPS doit contenir un maximum de 11 chiffres",
  pharmacistFinessFacturationLabel: "Saisissez le FINESS de facturation de l'officine",
  pharmacistFinessFacturationHint: "9 chiffres — différent du FINESS juridique",
  pharmacistInfoContinue: "Continuer",
  pharmacistBillingError:
    "Une erreur est survenue lors de l'enregistrement des informations de facturation.",
  pharmacistBillingSuccess: "Informations de facturation enregistrées",
  pharmacistEnterRppsPrefix: "Entrez le numéro RPPS du",
  pharmacistTitulaireLabel: "titulaire de l'officine",
  pharmacyLabel: "l'officine",
  pharmacistFinessHeadingBold: "FINESS de facturation",
  pharmacistFinessHeadingSuffix: "de l'établissement",
  pharmacistFinessInputPrefix: "Saisissez le FINESS de facturation de",
  dermatoSubReasonTitle: "Précisez vos motifs",
  dermatoPimpleAcne: "Acné",
  dermatoPimpleRecentlyAppeared: "Boutons apparus récemment",
  dermatoPimplePersistentAndRecurrent: "Boutons récurrents et persistants",
  dermatoPimplePainfulAndSwollen: "Boutons douloureux et gonflés",
  dermatoPimpleWithPus: "Boutons avec du pus",
  dermatoPimpleSubcutaneousCysts: "Kystes sous-cutanés douloureux",
  dermatoOtherUnusualHairLoss: "Chute de cheveux inhabituelle",
  dermatoOtherNailPeelingOrThickeningOrColoring: "Ongle décollé, épaissi ou coloré",
  dermatoOtherVerrucousOrGrowthOnSkin: "Verrue ou excroissance sur la peau",
  dermatoOtherCicatriceChangedAppearance: "Cicatrice ayant changé d'aspect",
  dermatoOtherWhiteOrDepigmentedSpot: "Tache blanche ou dépigmentée",
  dermatoMolesSuspect: "Grain de beauté suspect",
  dermatoMolesChangedShape: "Grain de beauté ayant changé de forme",
  dermatoMolesRecentlyIncreased: "Grain de beauté ayant grossi récemment",
  dermatoMolesChangedColor: "Grain de beauté ayant changé de couleur",
  dermatoMolesBleedingOrOozing: "Grain de beauté qui saigne ou suinte",
  dermatoDarkSpotAppearedRecently: "Tache foncée apparue récemment",
  dermatoTreatmentLessEffective: "Traitement devenu moins efficace",
  dermatoTreatmentSkinReaction: "Réaction cutanée depuis le début d'un traitement",
  dermatoTreatmentIrritatedOrDrySkin: "Peau irritée ou sèche depuis le début d'un traitement",
  dermatoTreatmentSymptomsReturned: "Symptômes revenus après la fin du traitement",
  dermatoTreatmentDoubt: "Doute sur l'utilisation d'un traitement",
  dermatoItchingEczema: "Eczéma",
  dermatoRashHerpes: "Herpès",
  itching_after_contact_with_a_product: "Démangeaisons après contact avec un produit",
  itching_on_dry_skin: "Démangeaisons sur peau sèche",
  recurrent_itching: "Démangeaisons récurrentes",
  itching_after_a_sting: "Démangeaisons suite à une piqûre",
  nightly_itching: "Démangeaisons nocturnes",
  spread_out: "Éruption cutanée qui s'étend",
  medication_with_eruption: "Éruption cutanée après la prise d'un médicament",
  small_bumps_with_eruption: "Éruption cutanée avec de petites cloques",
  scales_with_eruption: "Éruption cutanée avec squames",
  sudden_eruption: "Éruption cutanée apparue soudainement",
  anamnesisQuestionsTitle: "Veuillez renseigner vos antécédents médicaux",
  anamnesisQuestionsTitle_relative_male:
    "Veuillez renseigner les antécédents médicaux de votre proche",
  anamnesisQuestionsTitle_relative_female:
    "Veuillez renseigner les antécédents médicaux de votre proche",
  waitingStaff: "Un membre du personnel est-il présent à vos côtés ?",
  waitingStaffSubtitlePrefix: "Vous devrez présenter votre moyen de paiement sans contact sur",
  waitingStaffSubtitleTerminal: "son terminal",
  waitingStaffSubtitleMandatory: "Sa présence est indispensable.",
  launchContactlessPayment: "OUI, CONTINUER",
  start: "Démarrer",
  checkupHealth: "Check-up santé",
  checkupOverview:
    "Le <b>check-up santé</b> vous permet d'évaluer facilement votre état de santé global en calculant votre IMC et en mesurant vos constantes.<br/><br/> Ce service est strictement <b>confidentiel</b>.",
  checkupEndedInformation_html:
    "Votre bilan est <b>terminé.</b> Vous pouvez dès à présent <b>imprimer vos résultats</b> pour les conserver.",
  previousButton: "Précédent",
  yourCheckupHealth: "Votre check-up santé",
  yourCheckupEnded: "Votre check-up santé est terminé.",
  checkupMissingData: "Données manquantes, calcul impossible.",
  chooseAPath: "Choisir un parcours",
  checkupAdvices: {
    bmi: {
      labelUnder185: "Maigreur",
      labelUnder25: "Normal",
      labelUnder30: "Surpoids",
      labelOver30: "Obésité",
      adviceUnder185:
        "Un avis médical peut vous aider à stabiliser votre poids.",
      adviceUnder25: "Vos résultats sont dans les normes recommandées.",
      adviceUnder30:
        "Résultat hors zone optimale. Une surveillance est conseillée.",
      adviceOver30: "Un avis médical est recommandé.",
      advice: "Vos résultats sont dans les normes recommandées.",
      massLabel: "Indice de Masse Corporelle",
    },
    heartRate: {
      labelLow: "Faible",
      labelNormal: "Normale",
      labelHigh: "Nomale haute",
      labelHypertension: "Hypertension",
      adviceLow: "Surveillez l'apparition de vertiges ou de fatigue.",
      adviceNormal: "Vos résultats sont dans les normes recommandées.",
      adviceHigh:
        "Résultat hors zone optimale. Une surveillance est conseillée.",
      adviceHypertension: "Un avis médical est recommandé.",
      generalAdvice: "Vos résultats sont à surveiller.",
      heartRateLabel: "Tension artérielle",
    },
    oxygenSaturation: {
      labelUnder90: "Hypoxie sévère",
      labelUnder95: "Hypoxie légère",
      labelOver95: "Normale",
      adviceUnder90: "Un avis médical est recommandé.",
      adviceUnder95:
        "Résultat hors zone optimale. Une surveillance est conseillée.",
      adviceOver95: "Vos résultats sont dans les normes recommandées.",
      oxygenSaturationLabel: "Saturation d'oxygène",
    },
  },
  checkUpEndComment: "Pour toute question sur vos constantes, vous pouvez dès à présent lancer une téléconsultation, ou bien choisir de vous déconnecter.",
  technical_diagnostic: "diagnostic technique",
  diagnosticCompleted: "Diagnostic technique terminé",
  completeDiagnostic: "Terminer le diagnostic",
  checkupDocumentError: "Le document du check-up n'a pas pu être généré",
  checkupDocumentMissingData: "Données manquantes, impossible de générer le check-up santé.",
  checkupDocumentSentError: "Le document du check-up n'a pas pu être envoyé",
  checkupDocumentSentSuccess: "Le document du check-up a bien été envoyé",
  microphoneAndCameraWorkCorrectly: "Le micro et la caméra semblent fonctionner correctement.",
  nurse: "Infirmier(e)",
  sendReportToMT: "récupération automatique de mon médecin traitant et envoi du compte-rendu à celui-ci en cas de prise en charge hors résidence habituelle",
  youWillAttendedInPriority: "Vous serez pris en charge en priorité",
  mediaProblemDetected:
    "Problème de <b>son ou vidéo</b> détecté.<br />Vérifiez que votre <b>caméra</b> et/ou votre <b>micro</b> sont bien branchés.<br />Si le problème persiste <b>cliquez sur “Actualiser”</b>.",
  mediaProblemBadge: "Problème de son ou vidéo",
  refreshPage: "Actualiser",
}

export default fr
